import React, { useEffect, useState, useRef } from "react";
import { Box, Tabs, Tab, Grid, Typography, Button, Divider, Modal, Dialog, CircularProgress, IconButton, useMediaQuery, useTheme, Select, MenuItem, FormControl, TextField, InputAdornment, Badge, Link, Avatar, Drawer } from "@mui/material";
import Stack from "@mui/material/Stack";
import API_MIDDLEWARE from "../../redux/api/middleware";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { setErrorMessage } from "../../redux/actions/appActions";
import { APP_CUSTOM_ERROR, ACCESS_TOKEN } from "../../constants/AppVarConstants";
import { READ_USER_VIDEOS, UPDATE_APPLICANT_VIEW_URL } from "../../redux/api/config";
import { getApplicantDetails, getB2BJobDetails, getB2BJobApplicants, getShareProfileApplicants, validateShareLink, validateSharePassword, updateJobAction, updateVideoAction, updateBestFitStatus, getApplicantReport, getApplicantPersonality, getApplicantTopicScore, getApplicantScoreBand, saveCommentApplicantView, clearApplicantDetails, saveJobViews, getOrganizationJobs, updatePrimaryStatus, updateReachoutStatus } from "../../redux/actions/b2bActions";
import { SET_B2B_JOB_APPLICANTS } from "../../redux/actions/actionTypes";
import moment from "moment";
import VideoThumbnail from "../common/VideoThumbnail";
import ReactPlayer from "react-player";
import B2BHeader from "./B2BHeader";
import { ROUTE_PERSONALITY_PROFILER, ROUTE_VIEW_JOB, ROUTE_JOB_DETAILS, ROUTE_PUBLIC_JOB_DETAILS } from "../../constants/routes";
import { ArrowForward, Close as CloseIcon } from "@mui/icons-material";
import VideoDetailheader from "./videoDetailheader";
import Applicants from "./applicants";
import CommentPopup from "./comment";
import ReportView from "./ReportView";
import SharePopup from "./sharecandidate";
import ShareSuccessPopup from "./ShareSuccessPopup";


const styles = {
  subText: {
    fontSize: "16px",
    color: "#777777",
    fontWeight: "400",
  },
  text: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#000000",
  },
  tabStyle: {
    fontWeight: "bold",
  },
  indicator: {
    backgroundColor: "#756de9 !important",
    height: "4px",
  },
  modalContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: 24,
  },

  modalContentDecline: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "300px",
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: 24,
  },
};

const SHARE_PASSWORD_STORAGE_PREFIX = "share_password_verified_";
const getSharePasswordStorageKey = (profileId: string) => `${SHARE_PASSWORD_STORAGE_PREFIX}${profileId}`;

const ShareJobDetails = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const location = useLocation();
  const params = useParams();
  const jobId = params.jobId;
  // Share profile: /shareprofile/:jobId/:profileid; Candidate profile: /candidate-profile/:profileName/:profileId
  const profileId = params.profileid || params.profileId;
  const isCandidateProfileRoute = location.pathname.startsWith('/candidate-profile/');
  /** Public share link on a narrow viewport: prioritize candidate switcher over job title */
  const isShareProfileMobile = Boolean(profileId && isMobile);
  const navigate = useNavigate();
  const { applicantDetails, b2bJobDetails, b2bJobApplicants, applicantReport, applicantPersonality, applicantTopicScore, applicantScoreBand, shareLinkValidation, sharePasswordValidation } = useSelector((state: any) => state.b2b);
  const userRole = useSelector((state: any) => state.app.userRole);
  const roles = localStorage.getItem("roles");
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  const isAuthenticated = !!accessToken;

  // Check if user has seevi_admin role to show Best Fit functionality
  // Hide Best Fit functionality when profileId is set (share profile view)
  const canShowBestFit = () => {
        return roles?.includes('seevi_admin') && !profileId;
  };
  
  const [hasMoreApplicants, setHasMoreApplicants] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [selectedApplicantDetails, setSelectedApplicantDetails] = useState<any>(null);
  const [selectedApplicantId, setSelectedApplicantId] = useState<number | null>(null);
  const [applicantSelectionKey, setApplicantSelectionKey] = useState(0);
  const [lastFetchedApplicantId, setLastFetchedApplicantId] = useState<number | null>(null);
  const hasAutoSelectedRef = useRef(false);
  const playerRef = useRef<any>(null);
  const [selectedCandidates, setSelectedCandidates] = useState<any[]>([]);
  const [applicants, setApplicants] = useState<any>([]);
  const [currentApplicantsPage, setCurrentApplicantsPage] = useState(1);
  const [loadingApplicants, setLoadingApplicants] = useState(false);
  const [loadingApplicantDetails, setLoadingApplicantDetails] = useState(false);
  const [organizationJobs, setOrganizationJobs] = useState<any[]>([]);
  const [loadingOrganizationJobs, setLoadingOrganizationJobs] = useState(false);
  const [activeApplicantsTab, setActiveApplicantsTab] = useState(0);
  const [activeTab1, setActiveTab1] = useState(0);
  const [currentActive, setCurrentActive] = useState(0);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openBestFitModal, setOpenBestFitModal] = useState(false);
  const [loadingBestFit, setLoadingBestFit] = useState(false);
  const [loadingShortlist, setLoadingShortlist] = useState(false);
  const [loadingReachout, setLoadingReachout] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openShareSuccessModal, setOpenShareSuccessModal] = useState(false);
  const [shareSuccessUrl, setShareSuccessUrl] = useState("");
  const [selectedAccount, setSelectedAccount] = useState('Account Management');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const [openReportView, setOpenReportView] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [linkExpired, setLinkExpired] = useState(false);
  const [isValidatingLink, setIsValidatingLink] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [isValidatingPassword, setIsValidatingPassword] = useState(false);
  const [candidateOverflowOpen, setCandidateOverflowOpen] = useState(false);
  const [overflowSearchQuery, setOverflowSearchQuery] = useState('');
  const { userDetail, educationDetails, profileDetail, userCertificates, userExperience, userPersonality, userVideos } =
    applicantDetails || {};
  const [currentQuestionId, setCurrentQuestionId] = useState(-1);

  const { fullName, profileImage, dob, city, phoneNumber, email, gender } = userDetail || {};
  // const { videoUploaded, videoStatus } = profileStatus || {};
  const {
    languages,
    skills,
    tools,
    profilePicturePath,
    workLinks,
    work_links: workLinksSnake,
    workLink,
    work_link: shareWorkLinkSnake,
  } = profileDetail || {};
  const resolvedShareWorkLinks: string[] = (() => {
    const fromArray = workLinks ?? workLinksSnake;
    if (Array.isArray(fromArray)) return fromArray.map((v: any) => String(v ?? "").trim()).filter(Boolean);
    const fromSingle = workLink ?? shareWorkLinkSnake;
    return fromSingle != null && String(fromSingle).trim() !== "" ? [String(fromSingle).trim()] : [];
  })();
  const formatShareWorkLinkHref = (raw: string) => {
    const t = String(raw).trim();
    if (!t) return "#";
    if (/^https?:\/\//i.test(t)) return t;
    return `https://${t}`;
  };

  const handleSelectApplicant = async (item: any, details: any) => {
    console.log('handleSelectApplicant called:', { item, details, selectedApplicant, selectedApplicantId });
    
    // Check if this is the same applicant being re-selected
    const isSameApplicant = selectedApplicant === item && 
      selectedApplicantId === (details?.applicationId || details?.userId);
    
    console.log('isSameApplicant check:', { 
      selectedApplicant, 
      item, 
      selectedApplicantId, 
      applicationId: details?.applicationId, 
      userId: details?.userId,
      isSameApplicant 
    });
    
    setSelectedApplicant(item);
    setSelectedApplicantDetails(details);
    setSelectedApplicantId(details?.applicationId || details?.userId);
    setCurrentActive(0); // Reset to first video when selecting new applicant

    // Only show loading and fetch data if it's a different applicant
    if (!isSameApplicant) {
      console.log('Fetching applicant details for new applicant:', item);
      setLoadingApplicantDetails(true);
      // Increment selection key to force reload for new applicant
      setApplicantSelectionKey(prev => prev + 1);
      // Track the last fetched applicant ID
      setLastFetchedApplicantId(item);

      // Clear and reload to ensure fresh data
      dispatch(clearApplicantDetails());
      // Small delay to ensure clear completes before fetching
      setTimeout(() => {
        console.log('Calling getApplicantDetails with userId:', item);
        dispatch(getApplicantDetails(item));
      }, 10);
    } else {
      console.log('Same applicant selected, skipping API call');
    }

    // Check if applicant is new (applicationId not in viewedApplicants array)
    const isNewApplicant = details?.applicationId && 
      (!details?.viewedApplicants || !details.viewedApplicants.includes(details.applicationId));

    // Update the applicant's viewedApplicants array in Redux state immediately (optimistic update)
    if (isNewApplicant && b2bJobApplicants?.records) {
      const updatedRecords = b2bJobApplicants.records.map((applicant: any) => {
        if (applicant.applicationId === details.applicationId) {
          return {
            ...applicant,
            isNew: false,
            viewedApplicants: applicant.viewedApplicants 
              ? [...applicant.viewedApplicants, details.applicationId]
              : [details.applicationId]
          };
        }
        return applicant;
      });

      dispatch({
        type: SET_B2B_JOB_APPLICANTS,
        payload: {
          ...b2bJobApplicants,
          records: updatedRecords
        }
      });
    }

    // Call API if applicant is new (fire and forget - state already updated)
    if (isNewApplicant && jobId && details?.applicationId) {
      API_MIDDLEWARE(
        UPDATE_APPLICANT_VIEW_URL,
        "POST",
        { "Content-Type": "application/json" },
        {
          jobId: parseInt(jobId),
          applicantId: details.applicationId
        }
      ).catch((err: any) => {
        // Silently fail - don't show error to user as this is a background update
        console.error("Error updating applicant view:", err);
        // Optionally revert the optimistic update on error
      });
    }
  };

  const handleVideoClick = (index: any, questionId: any) => {
    setCurrentActive(index);
    setCurrentQuestionId(questionId);
  };
  const fetchApplicants = (flag: boolean, resetOffset: boolean, jobAction = false) => {
    if (!flag) {
      setLoadingApplicants(true);
    }
    
    const page = jobAction ? currentApplicantsPage : resetOffset ? 1 : currentApplicantsPage + 1;
    
    // Check if this is a share profile route
    if (profileId) {
      // Use the share profile API
      dispatch(getShareProfileApplicants(profileId));
    } else if (jobId) {
      // Use the regular job applicants API
      dispatch(getB2BJobApplicants(jobId, page, 10000, ""));
    }
  };

  // Group applicants by status with deduplication
  const groupedApplicants = React.useMemo(() => {
    if (!b2bJobApplicants?.records) return { APPLIED: [], SHORTLISTED: [] };
    
    // Debug: Log the API response
    console.log('B2B Job Applicants API Response:', b2bJobApplicants);
    console.log('Records:', b2bJobApplicants.records);
    
    const deduplicatedRecords = b2bJobApplicants.records;

    const grouped = deduplicatedRecords.reduce((acc: any, applicant: any) => {
      const status = applicant.applicationStatus;
      if (!acc[status]) {
        acc[status] = [];
      }
      acc[status].push(applicant);
      return acc;
    }, {});
    
    // Show all candidates in APPLIED tab regardless of status (already deduplicated)
    const allApplicants = deduplicatedRecords;
    
    return {
      APPLIED: allApplicants,
      SHORTLISTED: grouped.SHORTLIST || []
    };
  }, [b2bJobApplicants]);

  // Update applicants state when b2bJobApplicants changes
  React.useEffect(() => {
    if (b2bJobApplicants) {
      setApplicants(b2bJobApplicants.records || []);
      setCurrentApplicantsPage(b2bJobApplicants.page || 1);
      setHasMoreApplicants(b2bJobApplicants.hasNext || false);
      setLoadingApplicants(false);
    }
  }, [b2bJobApplicants]);

  useEffect(() => {
    // Clear previous applicant details when component loads or jobId changes
    dispatch(clearApplicantDetails());
    // Reset auto-selection ref when profileId changes
    hasAutoSelectedRef.current = false;
    
    // Handle candidate profile route - fetch applicant directly
    if (isCandidateProfileRoute && profileId) {
      setLoadingApplicantDetails(true);
      // Fetch applicant details directly using profileId as userId
      dispatch(getApplicantDetails(profileId));
      return;
    }
    
    // Fetch job details when component loads (for both regular and shareprofile routes)
    if (jobId) {
      dispatch(getB2BJobDetails(jobId));
      
      // Save job view only if user is authenticated and it's not a shareprofile route
      const accessToken = localStorage.getItem(ACCESS_TOKEN);
      if (accessToken && !profileId) {
        dispatch(saveJobViews(
          parseInt(jobId),
          (response: any) => {
            console.log('Job view saved successfully:', response);
          },
          (error: any) => {
            console.error('Failed to save job view:', error);
          }
        ));
      }
    }
    
    // If this is a share profile route, validate the link first
    if (profileId && !isCandidateProfileRoute) {
      const alreadyVerified = localStorage.getItem(getSharePasswordStorageKey(profileId)) === "true";
      setIsValidatingLink(true);
      dispatch(validateShareLink(
        profileId,
        (validationResult: any) => {
          setIsValidatingLink(false);
          if (!validationResult.isValid || validationResult.isExpired) {
            setLinkExpired(true);
          } else if (validationResult.isPasswordProtected) {
            if (alreadyVerified) {
              fetchApplicants(false, true);
            } else {
              console.log('Setting password modal to open');
              setOpenPasswordModal(true);
            }
          } else {
            // Link is valid and not password protected, fetch applicants
            fetchApplicants(false, true);
          }
        },
        (error: any) => {
          setIsValidatingLink(false);
          setLinkExpired(true);
        }
      ));
    } else if (!isCandidateProfileRoute) {
      fetchApplicants(false, true);
    }
  }, [jobId, profileId, isCandidateProfileRoute, dispatch]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(clearApplicantDetails());
    };
  }, [dispatch]);

  useEffect(() => {
    // For candidate profile route, auto-select when applicant details are loaded
    if (isCandidateProfileRoute && applicantDetails && Object.keys(applicantDetails).length > 0 && !selectedApplicant) {
      const userId = applicantDetails?.userDetail?.userId || profileId;
      if (userId) {
        setSelectedApplicant(userId);
        setSelectedApplicantId(userId);
        setSelectedUserId(userId);
        // Set basic details from applicantDetails
        if (applicantDetails.userDetail) {
          setSelectedApplicantDetails({
            userId: userId,
            fullName: applicantDetails.userDetail.fullName,
            profilePicturePath: applicantDetails.userDetail.profileImage,
            ...applicantDetails.userDetail
          });
        }
      }
      return;
    }

    if (applicants?.length) {
      // If we have a previously selected applicant ID, try to restore it
      if (selectedApplicantId) {
        const previouslySelectedApplicant = applicants.find(
          (app: any) => (app.applicationId === selectedApplicantId) || (app.userId === selectedApplicantId)
        );
        if (previouslySelectedApplicant) {
          setSelectedApplicant(previouslySelectedApplicant.userId);
          setSelectedApplicantDetails(previouslySelectedApplicant);
          setSelectedUserId(previouslySelectedApplicant.userId);
          hasAutoSelectedRef.current = true; // Mark as auto-selected
          return; // Exit early if we found and restored the previous selection
        }
      }
      
      // For shareprofile page, automatically select the first candidate by default
      // Only do this once (tracked by ref to prevent infinite loops)
      if (profileId && !isCandidateProfileRoute && !selectedApplicant && !hasAutoSelectedRef.current) {
        const firstApplicant = applicants[0];
        if (firstApplicant) {
          const userId = firstApplicant.userId;
          hasAutoSelectedRef.current = true; // Mark as auto-selected before setting state
          setSelectedApplicant(userId);
          setSelectedApplicantDetails(firstApplicant);
          setSelectedApplicantId(firstApplicant.applicationId || firstApplicant.userId);
          setSelectedUserId(userId);
          // Fetch full applicant details
          setLoadingApplicantDetails(true);
          dispatch(clearApplicantDetails());
          setTimeout(() => {
            dispatch(getApplicantDetails(userId));
          }, 10);
        }
      }
    }
  }, [applicants, selectedApplicantId, isCandidateProfileRoute, applicantDetails, profileId, dispatch]);

  useEffect(() => {
    // Backup: Ensure API is called if applicant is selected but details haven't been fetched
    if (selectedApplicant && selectedApplicant !== lastFetchedApplicantId) {
      console.log('useEffect backup: Calling getApplicantDetails for selectedApplicant:', selectedApplicant, 'lastFetched:', lastFetchedApplicantId);
      setLoadingApplicantDetails(true);
      setLastFetchedApplicantId(selectedApplicant);
      dispatch(clearApplicantDetails());
      setTimeout(() => {
        dispatch(getApplicantDetails(selectedApplicant));
      }, 10);
    }
  }, [selectedApplicant, lastFetchedApplicantId, dispatch]);

  useEffect(() => {
    setCurrentQuestionId(userVideos?.[0]?.questionId);
  }, [userVideos]);

  // Turn off loading when applicant details are loaded
  useEffect(() => {
    if (applicantDetails && Object.keys(applicantDetails).length > 0) {
      setLoadingApplicantDetails(false);
    }
  }, [applicantDetails, userVideos]);

  // Fetch organization jobs when job details are loaded
  useEffect(() => {
    if (b2bJobDetails && b2bJobDetails.companyId) {
      setLoadingOrganizationJobs(true);
      dispatch(getOrganizationJobs(
        b2bJobDetails.companyId,
        (response: any) => {
          console.log('Organization jobs API response:', response);
          console.log('Response structure:', {
            response,
            result: response?.result,
            records: response?.result?.records,
            data: response?.data,
            jobs: response?.jobs
          });
          setOrganizationJobs(response?.result || []);
          setLoadingOrganizationJobs(false);
        },
        (error: any) => {
          console.error('Failed to fetch organization jobs:', error);
          setLoadingOrganizationJobs(false);
        }
      ));
    }
  }, [ dispatch]);

  const handleTabChange1 = (event: any, newValue: any) => {
    setActiveTab1(newValue);
  };

  const handleApplicantsTabChange = (newValue: number) => {
    setActiveApplicantsTab(newValue);
  };

  // State for handling the modal
  const [openModal, setOpenModal] = useState(false);
  const [openModalDecline, setOpenModalDecline] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenModalDecline = () => setOpenModalDecline(true);
  const handleCloseModalDecline = () => setOpenModalDecline(false);

  const handleJobAction = (jobStatus: any) => {
    // Set loading state based on action
    if (jobStatus === "ACCEPTED") {
      setLoadingReachout(true);
    } else if (jobStatus === "DECLINED") {
      setLoadingDecline(true);
    }
    
    // Call reachout status API for "ACCEPTED" (Reach Out)
    if (jobStatus === "ACCEPTED") {
      dispatch(
        updateReachoutStatus(selectedApplicantDetails?.applicationId, () => {
          // Success callback
          setLoadingReachout(false);
          // Close modal after successful API call
          handleCloseModal();
          console.log('Reachout status updated successfully');
        }, () => {
          // Error callback
          setLoadingReachout(false);
          console.error('Failed to update reachout status');
        })
      );
      return;
    }
    
    dispatch(
      updateJobAction(jobStatus, selectedApplicantDetails?.applicationId, () => {
        // Reset loading states
        setLoadingReachout(false);
        setLoadingDecline(false);
        
        if (jobStatus === "DECLINED") {
          // Update local state instead of calling API for DECLINED
          const updatedApplicants = applicants.map((applicant: any) => 
            applicant.applicationId === selectedApplicantDetails.applicationId
              ? { ...applicant, applicationStatus: "DECLINED" }
              : applicant
          );
          setApplicants(updatedApplicants);
          
          // Update Redux store to reflect the changes
          dispatch({
            type: SET_B2B_JOB_APPLICANTS,
            payload: {
              ...b2bJobApplicants,
              records: updatedApplicants
            }
          });
          
          // Update selected applicant details
          setSelectedApplicantDetails((prev: any) => ({
            ...prev,
            applicationStatus: "DECLINED"
          }));
          
          handleCloseModalDecline();
        } else if (jobStatus === "APPLIED" && selectedApplicantDetails?.applicationStatus === "DECLINED") {
          // Handle accepting a declined candidate (changing from DECLINED to APPLIED)
          const updatedApplicants = applicants.map((applicant: any) => 
            applicant.applicationId === selectedApplicantDetails.applicationId
              ? { ...applicant, applicationStatus: "APPLIED" }
              : applicant
          );
          setApplicants(updatedApplicants);
          
          // Update Redux store to reflect the changes
          dispatch({
            type: SET_B2B_JOB_APPLICANTS,
            payload: {
              ...b2bJobApplicants,
              records: updatedApplicants
            }
          });
          
          // Update selected applicant details
          setSelectedApplicantDetails((prev: any) => ({
            ...prev,
            applicationStatus: "APPLIED"
          }));
          
          handleCloseModalDecline();
        } else if (jobStatus === "BEST_FIT") {
          toggleBestFitModal();
        }
        
        // Only call API for other statuses
        if (jobStatus !== "DECLINED" && !(jobStatus === "APPLIED" && selectedApplicantDetails?.applicationStatus === "DECLINED")) {
          fetchApplicants(false, true);
        }
      })
    );
  };

  const handleBestFitAction = () => {
    if (selectedApplicantDetails?.applicationId && !loadingBestFit) {
      setLoadingBestFit(true);
      const isBestFit = !selectedApplicantDetails?.isBestFit;
      dispatch(
        updateBestFitStatus(
          selectedApplicantDetails.applicationId, 
          isBestFit, 
          () => {
            // Success callback
            setLoadingBestFit(false);
            
            // Update local state instead of calling API
            const updatedApplicants = applicants.map((applicant: any) => 
              applicant.applicationId === selectedApplicantDetails.applicationId
                ? { ...applicant, isBestFit: isBestFit }
                : applicant
            );
            setApplicants(updatedApplicants);
            
            // Update Redux store to reflect the changes
            dispatch({
              type: SET_B2B_JOB_APPLICANTS,
              payload: {
                ...b2bJobApplicants,
                records: updatedApplicants
              }
            });
            
            // Update selected applicant details
            setSelectedApplicantDetails((prev: any) => ({
              ...prev,
              isBestFit: isBestFit
            }));
            
            toggleBestFitModal();
          },
          () => {
            // Error callback
            setLoadingBestFit(false);
          }
        )
      );
    }
  };

  const handleShortlistAction = () => {
    if (selectedApplicantDetails?.applicationId && !loadingShortlist) {
      setLoadingShortlist(true);
      
      // Check if we're in the shortlist tab and the candidate is already shortlisted
      if (activeApplicantsTab === 1 && selectedApplicantDetails?.applicationStatus === "SHORTLIST") {
        // Call primary status update API
        dispatch(
          updatePrimaryStatus(selectedApplicantDetails.applicationId, () => {
            // Success callback
            setLoadingShortlist(false);
            
            // Toggle the isPrimary status locally
            const newIsPrimary = !selectedApplicantDetails.isPrimary;
            
            console.log('Primary status updated:', {
              applicationId: selectedApplicantDetails.applicationId,
              oldIsPrimary: selectedApplicantDetails.isPrimary,
              newIsPrimary: newIsPrimary
            });
            
            // Update applicants list with new isPrimary status
            const updatedApplicants = applicants.map((applicant: any) => 
              applicant.applicationId === selectedApplicantDetails.applicationId
                ? { ...applicant, isPrimary: newIsPrimary }
                : applicant
            );
            setApplicants(updatedApplicants);
            
            // Update Redux store to reflect the changes
            dispatch({
              type: SET_B2B_JOB_APPLICANTS,
              payload: {
                ...b2bJobApplicants,
                records: updatedApplicants
              }
            });
            
            // Update selected applicant details
            setSelectedApplicantDetails((prev: any) => ({
              ...prev,
              isPrimary: newIsPrimary
            }));
            
            // The candidate will automatically move between sections due to the filtering logic
            // Primary candidates (isPrimary: true) will show in "Primary Candidate List"
            // Secondary candidates (isPrimary: false) will show in "Secondary Candidate List"
            
            console.log('Candidate moved to:', newIsPrimary ? 'Primary Candidate List' : 'Secondary Candidate List');
          }, () => {
            // Error callback
            setLoadingShortlist(false);
            console.error('Failed to update primary status');
          })
        );
      } else {
        // Original shortlist/remove shortlist logic
        const action = selectedApplicantDetails?.applicationStatus === "SHORTLIST" ? "APPLIED" : "SHORTLIST";
        dispatch(
          updateJobAction(action, selectedApplicantDetails.applicationId, () => {
            // Success callback
            setLoadingShortlist(false);
            
            // Update local state instead of calling API
            const newStatus = action;
            // New shortlisted candidates go to primary list by default; user can move to secondary
            const isNewShortlist = newStatus === "SHORTLIST";
            
            // Update applicants list
            const updatedApplicants = applicants.map((applicant: any) => 
              applicant.applicationId === selectedApplicantDetails.applicationId
                ? { ...applicant, applicationStatus: newStatus, ...(isNewShortlist && { isPrimary: true }) }
                : applicant
            );
            setApplicants(updatedApplicants);
            
            // Update Redux store to reflect the changes
            dispatch({
              type: SET_B2B_JOB_APPLICANTS,
              payload: {
                ...b2bJobApplicants,
                records: updatedApplicants
              }
            });
            
            // Update selected applicant details
            setSelectedApplicantDetails((prev: any) => ({
              ...prev,
              applicationStatus: newStatus,
              ...(isNewShortlist && { isPrimary: true })
            }));
          })
        );
      }
    }
  };

  const handleCommentIconClick = () => {
    // Clear badge count locally for selected applicant
    if (selectedApplicantDetails?.unreadCommentCount && selectedApplicantDetails.unreadCommentCount > 0) {
      // Update selected applicant details to clear unread count
      setSelectedApplicantDetails((prev: any) => ({
        ...prev,
        unreadCommentCount: 0
      }));
      
      // Update the applicants list to clear unread count for this applicant
      const updatedApplicants = applicants.map((applicant: any) => 
        applicant.applicationId === selectedApplicantDetails.applicationId
          ? { ...applicant, unreadCommentCount: 0 }
          : applicant
      );
      setApplicants(updatedApplicants);
      
      // Update Redux store to reflect the changes
      dispatch({
        type: SET_B2B_JOB_APPLICANTS,
        payload: {
          ...b2bJobApplicants,
          records: updatedApplicants,
          totalUnreadCommentCount: Math.max(0, (b2bJobApplicants?.totalUnreadCommentCount || 0) - selectedApplicantDetails.unreadCommentCount)
        }
      });
    }
    
    // Open comment modal
    toggleCommentModal();
    
    // Call API in background if applicant is selected
    if (selectedApplicantDetails?.applicationId) {
      dispatch(
        saveCommentApplicantView(
          selectedApplicantDetails.applicationId,
          jobId,
          () => {
            // Success callback - API call completed
            console.log('Comment applicant view saved successfully');
          },
          (error: any) => {
            // Error callback
            console.error('Failed to save comment applicant view:', error);
          }
        )
      );
    }
  };

  const calculateYears = (startDate: string, endDate?: string): string => {
    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(); // Use current date if endDate is not provided

    let years = end.getFullYear() - start.getFullYear();
    const additionalMonths = end.getMonth() - start.getMonth();

    // Adjust years if the end month is earlier than the start month
    if (additionalMonths < 0 || (additionalMonths === 0 && end.getDate() < start.getDate())) {
      years -= 1;
    }

    return `${years} yrs`;
  };

  const formatDuration = (duration: string): string => {
    if (!duration) return ""; // Handle empty or invalid values

    const [value, unit] = duration.split(" - ");

    if (!value || !unit) return duration; // Return the original string if improperly formatted

    const formattedUnit =
      parseInt(value) > 1 && !unit.toLowerCase().endsWith("s")
        ? `${unit}s` // Pluralize by adding "s" if not already plural
        : unit;

    return `${value} ${formattedUnit}`;
  };

  const toggleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const toggleRejectModal = () => setOpenRejectModal(!openRejectModal);
  const toggleBestFitModal = () => setOpenBestFitModal(!openBestFitModal);
  const toggleCommentModal = () => setOpenCommentModal(!openCommentModal);
  const toggleShareModal = () => {
    setOpenShareModal(!openShareModal);
  };

  const handleShareSuccess = (shareUrl: string) => {
    setShareSuccessUrl(shareUrl);
    setOpenShareSuccessModal(true);
  };

  const toggleShareSuccessModal = () => {
    setOpenShareSuccessModal(!openShareSuccessModal);
  };
  const toggleReportView = () => {
    console.log('toggleReportView called, current state:', openReportView);
    setOpenReportView(!openReportView);
    console.log('toggleReportView - new state should be:', !openReportView);
  };

  const handlePasswordSubmit = () => {
    if (!password.trim()) {
      setPasswordError('Please enter a password');
      return;
    }

    if (!profileId) {
      setPasswordError('Invalid share link');
      return;
    }

    setIsValidatingPassword(true);
    setPasswordError('');

    dispatch(validateSharePassword(
      profileId!,
      password,
      (validationResult: any) => {
        setIsValidatingPassword(false);
        if (validationResult.isPasswordValid && validationResult.isValid) {
          // Password is correct, close modal and fetch applicants
          setOpenPasswordModal(false);
          if (profileId) {
            localStorage.setItem(getSharePasswordStorageKey(profileId), "true");
          }
          fetchApplicants(false, true);
        } else {
          // Password is incorrect
          setPasswordError('Incorrect password. Please try again.');
        }
      },
      (error: any) => {
        setIsValidatingPassword(false);
        setPasswordError('Password validation failed. Please try again.');
      }
    ));
  };

  const handleUserSelection = (userId: any) => {
    setSelectedUserId(userId);
    setSelectedApplicant(userId);
    setLoadingApplicantDetails(true);
    setCurrentActive(0); // Reset to first video when selecting new applicant
    const selectedUser = applicants.find((app: any) => app.userId === userId);
    if (selectedUser) {
      setSelectedApplicantDetails(selectedUser);
      setSelectedApplicantId(selectedUser?.applicationId || selectedUser?.userId);
    }
  };
  
  // Filter applicants based on search query
  const filteredApplicants = applicants?.filter((applicant: any) =>
    applicant.fullName?.toLowerCase().includes(userSearchQuery.toLowerCase())
  ) || [];

  const shareProfileCandidateDisplay = React.useMemo(() => {
    if (applicants.length <= 5) {
      return { visible: applicants, showMore: false, moreCount: 0, overflow: [] as any[] };
    }
    const selectedId = String(selectedUserId || selectedApplicant || "");
    let visible = applicants.slice(0, 4);
    const selectedIndex = applicants.findIndex((a: any) => String(a.userId) === selectedId);
    if (selectedIndex >= 4) {
      visible = [...applicants.slice(0, 3), applicants[selectedIndex]];
    }
    const visibleIds = new Set(visible.map((a: any) => a.userId));
    const overflow = applicants.filter((a: any) => !visibleIds.has(a.userId));
    return {
      visible,
      showMore: true,
      moreCount: applicants.length - 4,
      overflow,
    };
  }, [applicants, selectedUserId, selectedApplicant]);

  const overflowSheetApplicants = applicants.filter((applicant: any) =>
    applicant.fullName?.toLowerCase().includes(overflowSearchQuery.toLowerCase())
  );

  const handleCloseCandidateOverflow = () => {
    setCandidateOverflowOpen(false);
    setOverflowSearchQuery('');
  };

  const handleVideoModal = (status: string) => {
    dispatch(
      updateVideoAction(status, currentQuestionId, selectedApplicantDetails?.userId, () => {
        if (status === "APPROVED") {
          toggleApproveModal();
        } else {
          toggleRejectModal();
        }
        dispatch(getApplicantDetails(selectedApplicant));
      })
    );
  };

  // Show expired link message
  if (linkExpired) {
    return (
      <Box sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        padding: '20px'
      }}>
        <Box sx={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px',
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <Box sx={{ 
            width: "64px", 
            height: "64px", 
            backgroundColor: "#FFEBEE", 
            borderRadius: "50%", 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            margin: "0 auto 20px auto",
            border: "2px solid #FFCDD2"
          }}>
            <Typography sx={{ fontSize: "32px" }}>❌</Typography>
          </Box>
          <Typography variant="h5" sx={{ color: '#d32f2f', marginBottom: '16px', fontWeight: '600' }}>
            Link Expired
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', marginBottom: '24px' }}>
            This share link has expired or is no longer valid. Please contact the person who shared this link for a new one.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.close()}
            sx={{
              backgroundColor: '#756DE9',
              color: 'white',
              borderRadius: '8px',
              padding: '12px 24px',
              '&:hover': {
                backgroundColor: '#5f5bc4',
              }
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  }

  // Show loading while validating link (but still render Dialog for password modal)
  const loadingContent = isValidatingLink ? (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      <CircularProgress size={60} sx={{ color: '#756DE9', marginBottom: '20px' }} />
      <Typography variant="h6" sx={{ color: '#666' }}>
        Validating share link...
      </Typography>
    </Box>
  ) : null;

  // Don't show full-page loading - let the component structure render normally
  // The Applicants component and Select dropdown can handle their own loading states
  // Only show full-page loading when validating the link
  const renderMobileLoadingScreen = () => (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      width: '100%',
      position: 'relative'
    }}>
      {/* Mobile Header */}
      <Box sx={{
        backgroundColor: '#756DE9',
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src={profileId ? "/images/client-website/seevi-logo.png" : "/images/Seevi-Logo-White.png"} 
            alt="SeeVi" 
            style={{ height: '40px', width: 'auto' }} 
          />
        </Box>
      </Box>

      {/* Loading Content */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        backgroundColor: '#f5f5f5'
      }}>
        <CircularProgress size={60} sx={{ color: '#756DE9', marginBottom: '20px' }} />
        <Typography variant="h6" sx={{ color: '#666', textAlign: 'center', marginBottom: '8px' }}>
          Loading applicants...
        </Typography>
        <Typography variant="body2" sx={{ color: '#999', textAlign: 'center' }}>
          Please wait while we fetch the applicant information
        </Typography>
      </Box>
    </Box>
  );

  // Mobile/Tablet Layout
  const mobileContent = isMobile ? (
    <Box sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%',
        position: 'relative'
      }}>
        {/* Mobile Header - Show SeeVi logo for candidate profile route */}
        {isCandidateProfileRoute ? (
          <Box sx={{
            backgroundColor: '#756DE9',
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0
          }}>
            {/* Profile Picture and Name on Left */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
              <img
                src={profilePicturePath || selectedApplicantDetails?.profilePicturePath || applicantDetails?.userDetail?.profileImage || profileImage}
                width="40px"
                height="40px"
                style={{ borderRadius: '50%', objectFit: 'cover' }}
                alt="Profile"
              />
              <Typography sx={{
                color: 'white',
                fontSize: '16px',
                fontWeight: '600'
              }}>
                {selectedApplicantDetails?.fullName || applicantDetails?.userDetail?.fullName || fullName}
              </Typography>
            </Box>
            {/* Logo on Right */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img 
                src="/images/client-website/seevi-logo.png" 
                alt="SeeVi" 
                style={{ height: '40px', width: 'auto' }} 
              />
            </Box>
          </Box>
        ) : null}
        
        {/* Mobile Header - Hide for candidate profile route */}
        {!isCandidateProfileRoute && (
          <Box sx={{
            backgroundColor: '#756DE9',
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img 
                src={profileId ? "/images/client-website/seevi-logo.png" : "/images/Seevi-Logo-White.png"} 
                alt="SeeVi" 
                style={{ height: profileId ? '32px' : '20px', width: 'auto' }} 
              />
            </Box>
            <Box sx={{ display: 'flex', gap: '8px' }}>
              {!profileId && (
                <IconButton
                  onClick={toggleShareModal}
                  sx={{ color: 'white', padding: '4px' }}
                >
                  <img src="/images/share.svg" width="18px" height="18px" alt="Share" />
                </IconButton>
              )}
              <IconButton sx={{ color: 'white', padding: '4px' }}>
                <img src="/images/close.svg" width="18px" height="18px" alt="Close" />
              </IconButton>
            </Box>
          </Box>
        )}

        {/* Account Management Dropdown with Share Button - Hide for candidate profile route */}
        {!isCandidateProfileRoute && (
          <Box sx={{ padding: '8px 16px 12px 16px', backgroundColor: '#756DE9', flexShrink: 0 }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            ...(isShareProfileMobile ? {
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '6px',
            } : {}),
          }}>
            {/* Show Job Name with Arrow for shareprofile, Dropdown for regular route */}
            {profileId ? (
              <Box 
                onClick={() => {
                  if (jobId) {
                    // For mobile view, navigate to job-details page
                    // For desktop view, navigate to view-job page
                    if (isMobile) {
                      navigate(`${ROUTE_PUBLIC_JOB_DETAILS}/${jobId}`);
                    } else {
                      navigate(`${ROUTE_VIEW_JOB}?edit=false&jobId=${jobId}`);
                    }
                  }
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  ...(isShareProfileMobile ? {
                    flex: 'none',
                    alignSelf: 'stretch',
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderRadius: '8px',
                    padding: '6px 10px',
                    border: '1px solid rgba(255,255,255,0.12)',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                    },
                    '&:active': {
                      backgroundColor: 'rgba(255,255,255,0.14)',
                    },
                  } : {
                    flex: 1,
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    padding: '10px 12px',
                    gap: '8px',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }),
                }}
              >
                {isShareProfileMobile ? (
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '10px',
                      fontWeight: 600,
                      letterSpacing: '0.06em',
                      textTransform: 'uppercase',
                      color: 'rgba(255,255,255,0.45)',
                      flexShrink: 0,
                    }}
                  >
                    Role
                  </Typography>
                ) : null}
                <Typography sx={{
                  flex: 1,
                  fontSize: isShareProfileMobile ? '12px' : '13px',
                  color: isShareProfileMobile ? 'rgba(255,255,255,0.82)' : '#666',
                  fontWeight: isShareProfileMobile ? 400 : 500,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                }}>
                  {b2bJobDetails?.title || b2bJobDetails?.jobTitle || b2bJobDetails?.jobName || 'Job'}
                </Typography>
                <ArrowForward sx={{
                  fontSize: isShareProfileMobile ? '14px' : '18px',
                  color: isShareProfileMobile ? 'rgba(255,255,255,0.45)' : '#666',
                  flexShrink: 0,
                }} />
              </Box>
            ) : (
              <FormControl sx={{ flex: 1 }}>
                <Select
                  disabled={!isAuthenticated}
                  value={selectedAccount}
                  onChange={(e) => setSelectedAccount(e.target.value)}
                  displayEmpty
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '& .MuiSelect-select': {
                      padding: '10px 12px',
                      fontSize: '13px',
                      color: '#666',
                    },
                    '& .MuiSelect-icon': {
                      color: '#666',
                    },
                  }}
                >
                  <MenuItem value="Account Management">Account Management</MenuItem>
                  <MenuItem value="HR Management">HR Management</MenuItem>
                  <MenuItem value="Recruitment">Recruitment</MenuItem>
                  <MenuItem value="Talent Acquisition">Talent Acquisition</MenuItem>
                </Select>
              </FormControl>
            )}

            {/* Share Button - Hide for shareprofile route */}
            {!profileId && (
              <IconButton
                onClick={toggleShareModal}
                sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px',
                  padding: '8px',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover': {
                    backgroundColor: '#D6D0FF',
                  },
                }}
              >
                {/* Simple Share Icon - Three Connected Circles */}
                <Box sx={{ position: 'relative', width: '20px', height: '20px' }}>
                  {/* Top Left Circle (slightly lower) */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '3px',
                      left: '2px',
                      width: '5px',
                      height: '5px',
                      borderRadius: '50%',
                      backgroundColor: '#756DE9',
                    }}
                  />
                  {/* Top Right Circle */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '1px',
                      right: '2px',
                      width: '5px',
                      height: '5px',
                      borderRadius: '50%',
                      backgroundColor: '#756DE9',
                    }}
                  />
                  {/* Bottom Center Circle */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: '2px',
                      left: '50%',
                      width: '5px',
                      height: '5px',
                      borderRadius: '50%',
                      backgroundColor: '#756DE9',
                      transform: 'translateX(-50%)',
                    }}
                  />
                  {/* Connection Line - Top Left to Bottom Center */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '5px',
                      left: '4px',
                      width: '1px',
                      height: '10px',
                      backgroundColor: '#756DE9',
                      transform: 'rotate(25deg)',
                      transformOrigin: 'top',
                    }}
                  />
                  {/* Connection Line - Top Right to Bottom Center */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '3px',
                      right: '4px',
                      width: '1px',
                      height: '10px',
                      backgroundColor: '#756DE9',
                      transform: 'rotate(-25deg)',
                      transformOrigin: 'top',
                    }}
                  />
                </Box>
              </IconButton>
            )}
          </Box>
          </Box>
        )}

        {/* Candidate Info with User Selection Dropdown - Hide for candidate profile route */}
        {!isCandidateProfileRoute && (
          <Box sx={{
            backgroundColor: '#756DE9',
            padding: isShareProfileMobile ? '4px 16px 14px 16px' : '0 16px 12px 16px',
            flexShrink: 0,
          }}>
          {isShareProfileMobile ? (
            <Typography
              component="div"
              sx={{
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.92)',
                marginBottom: '8px',
                textShadow: '0 1px 2px rgba(31,34,53,0.2)',
              }}
            >
              Candidate
            </Typography>
          ) : null}
          {isShareProfileMobile ? (
            <>
              {loadingApplicants ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                  <CircularProgress size={24} sx={{ color: '#fff' }} />
                </Box>
              ) : applicants.length > 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1.5,
                    flexWrap: 'nowrap',
                    pb: 0.5,
                  }}
                >
                  {shareProfileCandidateDisplay.visible.map((applicant: any) => {
                    const isSelected =
                      String(selectedUserId || selectedApplicant) === String(applicant.userId);
                    const firstName = applicant.fullName?.split(' ')[0] || 'User';
                    return (
                      <Box
                        key={applicant.userId}
                        onClick={() => handleUserSelection(applicant.userId)}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          flex: '1 1 0',
                          minWidth: 0,
                          maxWidth: 56,
                          cursor: 'pointer',
                        }}
                      >
                        <Avatar
                          src={applicant.profilePicturePath || profileImage}
                          alt={applicant.fullName}
                          sx={{
                            width: 44,
                            height: 44,
                            border: '2px solid',
                            borderColor: isSelected ? '#fff' : 'transparent',
                            boxShadow: isSelected ? '0 0 0 2px #756DE9' : 'none',
                            opacity: isSelected ? 1 : 0.7,
                            transition: 'all 0.2s ease',
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: '11px',
                            fontWeight: isSelected ? 600 : 400,
                            color: isSelected ? '#fff' : 'rgba(255,255,255,0.75)',
                            mt: 0.5,
                            width: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                          }}
                        >
                          {firstName}
                        </Typography>
                      </Box>
                    );
                  })}
                  {shareProfileCandidateDisplay.showMore ? (
                    <Box
                      onClick={() => setCandidateOverflowOpen(true)}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flex: '1 1 0',
                        minWidth: 0,
                        maxWidth: 56,
                        cursor: 'pointer',
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 44,
                          height: 44,
                          bgcolor: 'rgba(255,255,255,0.2)',
                          color: '#fff',
                          fontSize: '11px',
                          fontWeight: 700,
                          border: '2px dashed rgba(255,255,255,0.5)',
                        }}
                      >
                        +{shareProfileCandidateDisplay.moreCount}
                      </Avatar>
                      <Typography
                        sx={{
                          fontSize: '11px',
                          fontWeight: 500,
                          color: 'rgba(255,255,255,0.75)',
                          mt: 0.5,
                          textAlign: 'center',
                        }}
                      >
                        more
                      </Typography>
                    </Box>
                  ) : null}
                </Box>
              ) : (
                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.7)',
                    fontSize: '14px',
                    fontStyle: 'italic',
                    textAlign: 'center',
                    py: 1,
                  }}
                >
                  No candidates found
                </Typography>
              )}
            </>
          ) : (
          <FormControl fullWidth>
            <Select
              value={selectedUserId || selectedApplicant || ''}
              onChange={(e) => handleUserSelection(e.target.value)}
              displayEmpty
              sx={{
                  backgroundColor: '#8B7ED8',
                  borderRadius: '8px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '& .MuiSelect-select': {
                    padding: '10px 12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  },
                  '& .MuiSelect-icon': {
                    color: 'white',
                  },
              }}
              renderValue={(value) => {
                const selectedUser = applicants.find((app: any) => app.userId === value);
                if (selectedUser) {
                  return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', minWidth: 0 }}>
                      <img
                        src={selectedUser.profilePicturePath || profileImage}
                        width={28}
                        height={28}
                        style={{ borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                        alt="Profile"
                      />
                      <Typography sx={{
                        color: 'white',
                        fontSize: '15px',
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        minWidth: 0,
                      }}>
                        {selectedUser.fullName || fullName}
                      </Typography>
                    </Box>
                  );
                }
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', minWidth: 0 }}>
                    <img
                      src={selectedApplicantDetails?.profilePicturePath || profileImage}
                      width={28}
                      height={28}
                      style={{ borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                      alt="Profile"
                    />
                    <Typography sx={{
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: 500,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      minWidth: 0,
                    }}>
                      {selectedApplicantDetails?.fullName || fullName}
                    </Typography>
                  </Box>
                );
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: '#8B7ED8',
                    borderRadius: '8px',
                    marginTop: '4px',
                    maxHeight: '300px',
                    '& .MuiMenuItem-root': {
                      color: 'white',
                      padding: '10px 12px',
                      '&:hover': {
                        backgroundColor: '#756DE9',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#756DE9',
                        '&:hover': {
                          backgroundColor: '#756DE9',
                        },
                      },
                    },
                  },
                },
              }}
            >
              {/* Search Input */}
              <Box sx={{
                padding: '8px 12px',
                borderBottom: '1px solid rgba(255,255,255,0.2)',
              }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search users..."
                  value={userSearchQuery}
                  onChange={(e) => setUserSearchQuery(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      borderRadius: '8px',
                      '& fieldset': {
                        border: '1px solid rgba(255,255,255,0.3)',
                      },
                      '&:hover fieldset': {
                        border: '1px solid rgba(255,255,255,0.5)',
                      },
                      '&.Mui-focused fieldset': {
                        border: '1px solid rgba(255,255,255,0.7)',
                      },
                    },
                    '& .MuiInputBase-input': {
                      color: 'white',
                      fontSize: '14px',
                      '&::placeholder': {
                        color: 'rgba(255,255,255,0.7)',
                        opacity: 1,
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src="/images/search.svg" width="16px" height="16px" alt="Search" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              {/* Filtered Applicants List */}
              {loadingApplicants ? (
                <MenuItem disabled>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', padding: '10px' }}>
                    <CircularProgress size={16} sx={{ color: 'rgba(255,255,255,0.7)' }} />
                    <Typography sx={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '14px',
                      fontStyle: 'italic',
                    }}>
                      Loading applicants...
                    </Typography>
                  </Box>
                </MenuItem>
              ) : filteredApplicants.length > 0 ? (
                filteredApplicants.map((applicant: any) => (
                  <MenuItem key={applicant.userId} value={applicant.userId}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                      <img
                        src={applicant.profilePicturePath}
                        width={28}
                        height={28}
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                        alt="Profile"
                      />
                      <Typography sx={{
                        color: 'white',
                        fontSize: '15px',
                        fontWeight: 500,
                      }}>
                        {applicant.fullName}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  <Typography sx={{
                    color: 'rgba(255,255,255,0.7)',
                    fontSize: '14px',
                    fontStyle: 'italic',
                    textAlign: 'center',
                    width: '100%'
                  }}>
                    No users found
                  </Typography>
                </MenuItem>
              )}
            </Select>
          </FormControl>
          )}
          </Box>
        )}

        {/* Navigation Tabs */}
        <Box sx={{
          backgroundColor: '#756DE9',
          padding: '0 16px 12px 16px',
          flexShrink: 0,
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none', // Hide scrollbar for cleaner look
          },
          scrollbarWidth: 'none', // Firefox
        }}>
          <Tabs
            value={activeTab1}
            onChange={handleTabChange1}
            variant={isMobile ? "scrollable" : "fullWidth"}
            scrollButtons={false}
            sx={{
              minHeight: '36px',
              '& .MuiTab-root': {
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '13px',
                fontWeight: '500',
                textTransform: 'none',
                minHeight: '36px',
                padding: '6px 16px',
                minWidth: isMobile ? 'auto' : 0,
                whiteSpace: 'nowrap',
              },
              '& .Mui-selected': {
                color: 'white !important',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#FF6B35',
                height: '2px',
              },
            }}
          >
            <Tab label="Video" />
            <Tab label="Profile" />
            <Tab label="Specialization" />
            <Tab label="Personality" />
          </Tabs>
        </Box>

        {/* Main Content Area */}
        <Box sx={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: 'white',
          width: '100%',
          minHeight: 0,
        }}>
          {loadingApplicantDetails ? (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '100%',
              flexDirection: 'column'
            }}>
              <CircularProgress size={40} />
              <Typography sx={{ mt: 2, color: '#666' }}>Loading applicant details...</Typography>
            </Box>
          ) : (
            <>
              {!selectedApplicant ? (
                // Show placeholder when no applicant is selected
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  padding: '40px 20px',
                  textAlign: 'center'
                }}>
                  <img src="/images/video-icon.png" alt="No applicant" style={{ width: '64px', height: '64px', opacity: 0.5, marginBottom: '20px' }} />
                  <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px', color: '#333' }}>
                    No applicant selected
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '16px', color: '#666', lineHeight: 1.5, maxWidth: '300px' }}>
                    Select an applicant from the list to view their profile details, videos, and other information
                  </Typography>
                </Box>
              ) : (
                <>
                  {activeTab1 === 0 && (
                <Box>
              {/* Video Player */}
              <Box sx={{ position: 'relative', backgroundColor: '#000' }}>
                {userVideos?.length && userVideos[currentActive] ? (
                  <ReactPlayer
                    ref={playerRef}
                    height={350}
                    url={userVideos[currentActive]?.videoPath}
                    width="100%"
                    controls
                    playing={false}
                    playsinline={false}
                    onPlay={() => {
                      // Request fullscreen on mobile when video starts playing
                      if (isMobile && playerRef.current) {
                        const player = playerRef.current.getInternalPlayer();
                        if (player && player.requestFullscreen) {
                          player.requestFullscreen().catch((err: any) => {
                            console.log('Fullscreen request failed:', err);
                          });
                        } else if (player && (player as any).webkitEnterFullscreen) {
                          // iOS Safari
                          (player as any).webkitEnterFullscreen();
                        } else if (player && (player as any).mozRequestFullScreen) {
                          // Firefox
                          (player as any).mozRequestFullScreen();
                        } else if (player && (player as any).msRequestFullscreen) {
                          // IE/Edge
                          (player as any).msRequestFullscreen();
                        }
                      }
                    }}
                    config={{
                      file: {
                        attributes: {
                          controlsList: 'nodownload',
                          playsInline: false,
                        },
                      },
                      youtube: {
                        playerVars: {
                          playsinline: 0,
                          fs: 1,
                        },
                      },
                    }}
                  />
                ) : (
                  <Box sx={{
                    height: 350,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                    color: '#666'
                  }}>
                    <img src="/images/video-icon.png" alt="No video" style={{ width: '48px', height: '48px', opacity: 0.5, marginBottom: '12px' }} />
                    <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: '500', marginBottom: '4px' }}>
                      No video selected
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#999', textAlign: 'center' }}>
                      Select an applicant to view their video responses
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Video Description for Mobile */}
              {userVideos?.length && userVideos[currentActive] && (
                <Box sx={{ padding: '8px 12px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                  <Typography variant="h6" fontSize={"14px"} sx={{ fontWeight: '600', marginBottom: '2px', lineHeight: 1.2 }}>
                    {userVideos[currentActive]?.topic || "About You"}
                  </Typography>
                  <Typography variant="body2" fontSize={"12px"} sx={{ color: '#666', lineHeight: 1.3 }}>
                    {userVideos[currentActive]?.question || "What do you think is your most unique trait and characteristics?"}
                  </Typography>
                </Box>
              )}

              {/* Video Content Sections - Horizontal Scrollable Thumbnails */}
              <Box sx={{ padding: '12px' }}>
                {userVideos?.length ? (
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '12px',
                      overflowX: 'auto',
                      paddingBottom: '8px',
                      '&::-webkit-scrollbar': {
                        height: '4px',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '2px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#756DE9',
                        borderRadius: '2px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#5f5bc4',
                      },
                    }}
                  >
                    {userVideos?.map((el: any, index: number) => (
                      <Box
                        key={index}
                        sx={{
                          cursor: 'pointer',
                          flex: userVideos.length <= 3 ? 1 : 'none',
                          minWidth: userVideos.length <= 3 ? 'auto' : '80px',
                          maxWidth: userVideos.length <= 3 ? 'none' : '80px',
                          borderRadius: '10px',
                          backgroundColor: currentActive === index ? '#E8E4FF' : '#F8F9FA',
                          border: currentActive === index ? '2px solid #756DE9' : '1px solid #E0E0E0',
                          transition: 'all 0.2s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '&:hover': {
                            backgroundColor: currentActive === index ? '#E8E4FF' : '#F0F0F0',
                            border: currentActive === index ? '2px solid #756DE9' : '1px solid #D6D0FF',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          }
                        }}
                        onClick={() => handleVideoClick(index, el?.questionId)}
                      >
                        {/* Video Thumbnail Only */}
                        <Box
                          sx={{
                            position: 'relative',
                            width: '100%',
                            aspectRatio: '1 / 1.3',
                            borderRadius: '6px',
                            overflow: 'hidden',
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #E0E0E0'
                          }}
                        >
                          <VideoThumbnail videoUrl={el?.videoPath} />
                          {currentActive === index && (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <img src="/images/Vector-play.png" width="10px" height="10px" alt="Playing" />
                            </Box>
                          )}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '200px',
                    flexDirection: 'column',
                    gap: '16px'
                  }}>
                    {selectedApplicant ? (
                      <>
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          No videos available for this applicant
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Videos will appear here once the applicant uploads them
                        </Typography>
                      </>
                    ) : (
                      <>
                        <img src="/images/video-icon.png" alt="No video" style={{ width: '48px', height: '48px', opacity: 0.5 }} />
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          Select an applicant to view videos
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Choose an applicant from the list to see their video responses
                        </Typography>
                      </>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {activeTab1 === 1 && (
            <Box sx={{ padding: '12px' }}>
              {/* Demographics Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Demographics
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <img src="/images/dob.png" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Date of Birth: {moment(dob).format("DD/MM/YYYY")}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <img src="/images/complete-profile/Gender.svg" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Gender: {gender || '—'}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <img src="/images/language.png" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Language: {languages?.join(", ")}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src="/images/location.png" width="16px" height="16px" />
                        <Typography sx={{ fontSize: '12px', color: '#666' }}>
                          Residence: {city}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {/* Education Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Education
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {educationDetails?.map((el: any, id: any) => (
                    <Box key={id} sx={{ marginBottom: id < educationDetails.length - 1 ? '16px' : '0' }}>
                      <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                        {el?.educationType === "Board" ? el?.board : el?.courseName} | {el?.educationType === "Board" ? el?.schoolName : el?.institutionName}
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/degree.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              {el?.educationType === "Board" ? `Board: ${el?.board}` : `Degree: ${el?.courseName}`}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              {el?.yetToGraduate
                                ? `Duration: Studying since ${el?.startDate}`
                                : `Duration: ${calculateYears(el.startDate, el.endDate)}, ${el.startDate} - ${el.endDate || "Present"}`}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/images/Grades.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Grades: {el?.percentage || 'N/A'}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                      {id < educationDetails.length - 1 && (
                        <Divider sx={{ marginTop: '12px', backgroundColor: '#E0E0E0' }} />
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* Experience Section */}
              <Box>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Experience
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {userExperience?.map((el: any, id: any) => (
                    <Box key={id}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                            {el?.designationName} | {el?.companyName}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/degree.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Function: {el?.departmentName || 'N/A'}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Job Type: Full-Time
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                            <img src="/images/location.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Work Mode: Hybrid
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/images/Calendar-new.png" width="14px" height="14px" />
                            <Typography sx={{ fontSize: '11px', color: '#666' }}>
                              Duration: {!el?.endDate
                                ? `${calculateYears(el?.startDate, new Date().toISOString())}, Currently Working Here`
                                : `${calculateYears(el.startDate, el.endDate)}, ${moment(el?.startDate).format("YYYY")} - ${moment(el?.endDate).format("YYYY")}`}
                            </Typography>
                          </Box>
                          {el?.workLink && (
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', marginBottom: '4px', width: '100%' }}>
                              <img src="/images/link.png" width="14px" height="14px" style={{ flexShrink: 0, marginTop: 2 }} alt="" />
                              <Typography
                                component="a"
                                href={el.workLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  fontSize: '11px',
                                  color: '#756DE9',
                                  textDecoration: 'underline',
                                  minWidth: 0,
                                  flex: 1,
                                  overflowWrap: 'anywhere',
                                  wordBreak: 'break-word',
                                }}
                              >
                                {el.workLink}
                              </Typography>
                            </Box>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                            Description
                          </Typography>
                          <Typography sx={{ fontSize: '11px', color: '#666', lineHeight: 1.4 }}>
                            {el?.description || 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.'}
                          </Typography>
                        </Grid>
                      </Grid>
                      {id < userExperience.length - 1 && (
                        <Divider sx={{ marginTop: '16px', marginBottom: '16px', backgroundColor: '#E0E0E0' }} />
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          )}

          {activeTab1 === 2 && (
            <Box sx={{ padding: '12px' }}>
              {/* Skill-sets Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Skill-sets
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {skills && skills.length > 0 ? (
                    <Typography sx={{ fontSize: '12px', color: '#666', lineHeight: 1.4 }}>
                      {skills.join(" | ")}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: '12px', color: '#999', fontStyle: 'italic', lineHeight: 1.4 }}>
                      No skills added yet
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Tools Known Section */}
              <Box sx={{ marginBottom: '20px' }}>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Tools Known
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {tools && tools.length > 0 ? (
                    <Typography sx={{ fontSize: '12px', color: '#666', lineHeight: 1.4 }}>
                      {tools.join(" | ")}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: '12px', color: '#999', fontStyle: 'italic', lineHeight: 1.4 }}>
                      No tools known yet
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Work link Section */}
              <Box sx={{ marginBottom: "20px" }}>
                <Box
                  sx={{
                    backgroundColor: "#E8E4FF",
                    borderRadius: "8px 8px 0 0",
                    padding: "8px 12px",
                    marginBottom: "0",
                  }}
                >
                  <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1F2235" }}>Work link</Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "white",
                    border: "1px solid #E8E4FF",
                    borderTop: "none",
                    borderRadius: "0 0 8px 8px",
                    padding: "12px",
                  }}
                >
                  {resolvedShareWorkLinks.length ? (
                    <Stack direction="column" spacing={0.75}>
                      {resolvedShareWorkLinks.map((wl: string, i: number) => (
                        <Link
                          key={`${wl}-${i}`}
                          href={formatShareWorkLinkHref(wl)}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ fontSize: "12px", color: "#756DE9", wordBreak: "break-all" }}
                        >
                          {wl}
                        </Link>
                      ))}
                    </Stack>
                  ) : (
                    <Typography sx={{ fontSize: "12px", color: "#999", fontStyle: "italic", lineHeight: 1.4 }}>
                      Not added
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Certifications Section */}
              <Box>
                <Box sx={{
                  backgroundColor: '#E8E4FF',
                  borderRadius: '8px 8px 0 0',
                  padding: '8px 12px',
                  marginBottom: '0'
                }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1F2235' }}>
                    Certifications
                  </Typography>
                </Box>
                <Box sx={{
                  backgroundColor: 'white',
                  border: '1px solid #E8E4FF',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '12px'
                }}>
                  {userCertificates && userCertificates.length > 0 ? (
                    <Grid container spacing={2}>
                      {userCertificates.map((el: any, index: number) => (
                        <Grid item xs={6} key={index}>
                          <Box sx={{ marginBottom: index < userCertificates.length - 1 ? '16px' : '0' }}>
                            <Typography sx={{ fontSize: '13px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                              {el?.certificateName} | {el?.institute}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                              <img src="/images/Calendar-new.png" width="14px" height="14px" />
                              <Typography sx={{ fontSize: '11px', color: '#666' }}>
                                Duration: {el?.courseDuration && formatDuration(el.courseDuration)}
                              </Typography>
                            </Box>
                            {el?.courseExpiry && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                <img src="/images/complete-profile/Course Expiry Date.svg" width="14px" height="14px" />
                                <Typography sx={{ fontSize: '11px', color: '#666' }}>
                                  Course Expiry Date: {moment(el?.courseExpiry)?.format("DD/MM/YYYY")}
                                </Typography>
                              </Box>
                            )}
                            {el?.certificateReceived && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <img src="/images/Tick.png" width="14px" height="14px" />
                                <Typography sx={{ fontSize: '11px', color: '#666' }}>
                                  Received Certificate
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Typography sx={{ fontSize: '12px', color: '#999', fontStyle: 'italic', lineHeight: 1.4 }}>
                      No certifications added yet
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          )}

          {activeTab1 === 3 && (
            <Box sx={{
              padding: '12px',
              textAlign: 'center',
              position: 'relative',
              zIndex: 1002,
              pointerEvents: 'auto'
            }}>
              <img src="/images/connector-image.png" alt="Connector" width="100px" style={{ marginBottom: '12px' }} />
              <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1F2235', marginBottom: '8px' }}>
                {userPersonality
                      ?.map((el: any) => el?.displayPersonalityType)
                      .reduce((acc: string[], curr: string, index: number, arr: string[]) => {
                        if (arr.length === 2 && index === 1) {
                          return [...acc, "and " + curr];
                        }
                        if (index === arr.length - 1 && arr.length > 1) {
                          return [...acc, "and " + curr];
                        }
                        return [...acc, curr];
                      }, [])
                      .join(userPersonality?.length === 2 ? " " : ", ")}
              </Typography>
              <Typography sx={{ fontSize: '12px', color: '#666', lineHeight: 1.4, marginBottom: '16px' }}>
                {userPersonality?.map((el: any) => el?.typeDescriptors).join(" ")}
              </Typography>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('Button clicked - opening report view');
                  console.log('Current openReportView state:', openReportView);
                  // Force state update even if already true to trigger re-render
                  setOpenReportView(false);
                  setTimeout(() => {
                    setOpenReportView(true);
                    console.log('Set openReportView to true after reset');
                  }, 0);
                }}
                sx={{
                  color: '#756DE9',
                  fontSize: '12px',
                  fontWeight: '600',
                  textTransform: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  margin: '0 auto',
                  padding: '12px 20px',
                  borderRadius: '8px',
                  border: '1px solid #756DE9',
                  backgroundColor: 'transparent',
                  minHeight: '48px',
                  zIndex: 1001,
                  position: 'relative',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#F8F7FF',
                    border: '1px solid #756DE9',
                  },
                  '&:active': {
                    backgroundColor: '#E8E4FF',
                    transform: 'scale(0.98)',
                  },
                }}
              >
                View Full Report
                <ArrowForward sx={{ fontSize: '14px' }} />
              </Button>
            </Box>
          )}
                </>
              )}
            </>
          )}
        </Box>

        {/* Mobile Bottom Navigation - Show when authenticated, or on candidate profile route, or share profile (profileId) so Reach Out is visible on mobile */}
        {(isAuthenticated || isCandidateProfileRoute || !!profileId) && (
          <Box sx={{
            backgroundColor: '#1F2235',
            padding: '8px 12px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '1px solid #333',
            flexShrink: 0
          }}>
            <Button
              onClick={handleOpenModal}
              sx={{
                color: 'white',
                fontSize: '12px',
                fontWeight: '500',
                textTransform: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                flex: 1,
                justifyContent: 'center',
                padding: '8px 4px'
              }}
            >
              <img src="/images/client-website/reach-out.png" width="14px" height="14px" alt="Reach Out" />
              Reach Out
            </Button>
          </Box>
        )}


        {/* Comment Popup */}
        <CommentPopup
          open={openCommentModal}
          onClose={toggleCommentModal}
          jobId={jobId ? parseInt(jobId) : undefined}
          receiverId={selectedApplicantDetails?.userId}
        />

        {/* Best Fit Modal */}
        {canShowBestFit() && (
        <Modal open={openBestFitModal} onClose={toggleBestFitModal}>
          <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "400px",
            backgroundColor: "white",
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
            outline: "none",
          }}>
            {/* Header with icon */}
            <Box sx={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
              <Box sx={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#E8F5E8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "16px",
              }}>
                <img src="/images/Tick.png" width="24px" height="24px" alt="Best Fit" />
              </Box>
              <Typography variant="h5" component="h2" sx={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#1F2235",
                margin: 0,
              }}>
                {selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'}
              </Typography>
            </Box>

            {/* Description */}
            <Typography sx={{
              fontSize: "14px",
              color: "#666666",
              marginBottom: "20px",
              lineHeight: 1.5,
            }}>
              {selectedApplicantDetails?.isBestFit 
                ? 'Are you sure you want to remove this candidate from the best fit status? This action will remove their top choice highlight.'
                : 'Are you sure you want to mark this candidate as the best fit for this position? This action will highlight them as your top choice.'
              }
            </Typography>

            {/* Candidate Info */}
            <Box sx={{
              display: "flex",
              alignItems: "center",
              padding: "16px",
              borderRadius: "12px",
              backgroundColor: "#F8F9FA",
              border: "1px solid #E8F5E8",
              marginBottom: "24px",
            }}>
              <img
                src={profilePicturePath || selectedApplicantDetails?.profilePicturePath}
                width="50px"
                height="50px"
                style={{ borderRadius: "50%", objectFit: "cover" }}
                alt="Candidate"
              />
              <Box sx={{ marginLeft: "12px", flex: 1 }}>
                <Typography sx={{
                  fontSize: "16px",
                  color: "#1F2235",
                  fontWeight: "500",
                  marginBottom: "4px",
                }}>
                  {selectedApplicantDetails?.fullName}
                </Typography>
                <Box sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}>
                  <img src="/images/Tick.png" width="12px" height="12px" style={{ marginRight: "4px" }} />
                  BEST FIT CANDIDATE
                </Box>
              </Box>
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
              <Button
                onClick={toggleBestFitModal}
                disabled={loadingBestFit}
                variant="outlined"
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#666666",
                  padding: "10px 24px",
                  textTransform: "none",
                  opacity: loadingBestFit ? 0.7 : 1,
                  "&:hover": {
                    borderColor: "#CCCCCC",
                    backgroundColor: "#F5F5F5",
                  },
                  "&:disabled": {
                    borderColor: "#E0E0E0",
                    color: "#666666",
                  },
                }}
              >
                Cancel
              </Button>
                <Button
                  onClick={handleBestFitAction}
                  disabled={loadingBestFit}
                  sx={{
                    backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: selectedApplicantDetails?.isBestFit ? "10px 32px" : "10px 24px",
                    minWidth: selectedApplicantDetails?.isBestFit ? "180px" : "auto",
                    textTransform: "none",
                    opacity: loadingBestFit ? 0.7 : 1,
                    "&:hover": {
                      backgroundColor: selectedApplicantDetails?.isBestFit ? "#d32f2f" : "#45a049",
                    },
                    "&:disabled": {
                      backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                      color: "#fff",
                    },
                  }}
                >
                  {loadingBestFit ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CircularProgress size={16} sx={{ color: '#fff' }} />
                      <Typography sx={{ fontSize: '14px' }}>
                        {selectedApplicantDetails?.isBestFit ? 'Removing...' : 'Marking...'}
                      </Typography>
                    </Box>
                  ) : (
                    selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'
                  )}
              </Button>
            </Box>
          </Box>
        </Modal>
        )}
      </Box>
    ) : null;

  // Don't show full-page loading - let the Applicants component handle loading state
  // This ensures the applicant list structure is always visible

  // Desktop Layout
  const desktopContent = (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {!isCandidateProfileRoute && (
        <VideoDetailheader 
          jobDetails={b2bJobDetails} 
          jobId={jobId} 
          profileId={profileId}
          organizationJobs={organizationJobs}
          loadingOrganizationJobs={loadingOrganizationJobs}
          isAuthenticated={isAuthenticated}
        />
      )}
      {/* Three horizontal sections */}
      <Box sx={{ 
        display: 'flex', 
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        m: 1 
      }}>
        {/* Section 1 - Left (Hide for candidate profile route) */}
        {!isCandidateProfileRoute && (
          <Box sx={{
            flex: 1,
            marginRight: '8px',
            marginTop: '8px',
            paddingLeft: '8px',
            backgroundColor: '#fafafa'
          }}>
            <Applicants 
              onCommentClick={() => { }} 
              onShareClick={toggleShareModal} 
              onSelectApplicant={handleSelectApplicant}
              onCheckboxChange={setSelectedCandidates}
              onTabChange={handleApplicantsTabChange}
              groupedApplicants={groupedApplicants}
              loading={loadingApplicants}
              selectedApplicantId={selectedApplicantId}
              selectedCandidates={selectedCandidates}
              totalUnreadCommentCount={(() => {
                const count = b2bJobApplicants?.totalUnreadCommentCount || 0;
                console.log('Passing totalUnreadCommentCount to Applicants:', count);
                console.log('b2bJobApplicants object:', b2bJobApplicants);
                return count;
              })()}
              hideSearch={true}
              hideComment={true}
              hideShare={true}
              showSharedProfiles={true}
              jobName={b2bJobDetails?.title || b2bJobDetails?.jobTitle || b2bJobDetails?.jobName || ''}
            />
            {/* Content for section 1 */}
          </Box>
        )}

        {/* Section 2 - Center */}
        <Box sx={{
          flex: isCandidateProfileRoute ? 3 : 2,
          minHeight: 0,
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          marginLeft: isCandidateProfileRoute ? '8px' : '16px',
          marginRight: '16px',
          backgroundColor: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: "#756DE9",
              padding: "10px",
              borderTopRightRadius: "10px",
              borderTopLeftRadius: "10px",
              justifyContent: "space-between"
            }}
          >
            <Box display={"flex"}>
              
              <img 
                src={profilePicturePath || selectedApplicantDetails?.profilePicturePath || profileImage} 
                width="50px" 
                height="50px"
                style={{ borderRadius: '50%', objectFit: 'cover' }}
              />
              <Grid sx={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                <Typography sx={{ fontSize: "18px", color: "#fff", fontWeight: "500", fontFamily: "DM Sans" }}>
                  {selectedApplicantDetails?.fullName || fullName}
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#fff", fontWeight: "400" }}>
                  {educationDetails?.some((el: any) => el?.yetToGraduate) ? "Studying Currently" : null}
                </Typography>
              </Grid>
            </Box>
            {/* Action buttons or SeeVi Logo */}
            <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
              {/* Show SeeVi logo for candidate profile route in desktop view */}
              {isCandidateProfileRoute ? (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <img 
                    src="/images/client-website/seevi-logo.png" 
                    alt="SeeVi" 
                    style={{ height: '40px', width: 'auto' }} 
                  />
                </Box>
              ) : (
                <>
                  {/* Best Fit Button */}
                  {selectedApplicantDetails && canShowBestFit() && (
                <Button
                  onClick={toggleBestFitModal}
                  disabled={loadingBestFit}
                  sx={{
                    backgroundColor: selectedApplicantDetails?.isBestFit ? '#f44336' : '#4CAF50',
                    color: '#fff',
                    borderRadius: '20px',
                    width: selectedApplicantDetails?.isBestFit ? '120px' : '60px',
                    height: '36px',
                    minWidth: selectedApplicantDetails?.isBestFit ? '120px' : '60px',
                    boxShadow: selectedApplicantDetails?.isBestFit ? '0 2px 8px rgba(244, 67, 54, 0.3)' : '0 2px 8px rgba(76, 175, 80, 0.3)',
                    '&:hover': {
                      backgroundColor: selectedApplicantDetails?.isBestFit ? '#d32f2f' : '#45a049',
                      boxShadow: selectedApplicantDetails?.isBestFit ? '0 4px 12px rgba(244, 67, 54, 0.4)' : '0 4px 12px rgba(76, 175, 80, 0.4)',
                      transform: 'scale(1.02)',
                    },
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px',
                    opacity: loadingBestFit ? 0.7 : 1,
                  }}
                >
                  {loadingBestFit ? (
                    <CircularProgress size={16} sx={{ color: '#fff' }} />
                  ) : (
                    <Typography
                      sx={{
                        fontSize: '10px',
                        fontWeight: '600',
                        lineHeight: 1,
                        textTransform: 'uppercase',
                      }}
                    >
                      {selectedApplicantDetails?.isBestFit ? 'Remove Best Fit' : 'Best Fit'}
                    </Typography>
                  )}
                </Button>
              )}

              {/* Comment view button - Only show if authenticated */}
              {false && isAuthenticated && (
                <Badge
                  badgeContent={selectedApplicantDetails?.unreadCommentCount || 0}
                  color="error"
                  invisible={!selectedApplicantDetails?.unreadCommentCount || selectedApplicantDetails?.unreadCommentCount === 0}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: '10px',
                      height: '16px',
                      minWidth: '16px',
                      borderRadius: '8px',
                    }
                  }}
                >
                  <IconButton
                    onClick={handleCommentIconClick}
                    sx={{
                      backgroundColor: "#AAA7E44D",
                      borderRadius: "6px",
                      p: "4px",
                      height: "38px",
                      width: "38px",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#AAA7E466",
                      },
                    }}
                  >
                    <img
                      src="/images/comment_white.svg"
                      color="white"
                      width="20px"
                      height="20px"
                    ></img>
                  </IconButton>
                </Badge>
              )}
                </>
              )}
            </Box>
          </Grid>

          {/* Scrollable content area */}
          <Box sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#c1c1c1",
              borderRadius: "3px",
              "&:hover": {
                backgroundColor: "#a8a8a8",
              },
            },
          }}>
            {loadingApplicantDetails ? (
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%',
                backgroundColor: "#fff"
              }}>
                <CircularProgress size={40} />
                <Typography sx={{ ml: 2, color: '#666' }}>Loading applicant details...</Typography>
              </Box>
            ) : !selectedApplicant ? (
              // Show placeholder when no applicant is selected
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                padding: '60px 40px',
                textAlign: 'center',
                backgroundColor: "#fff"
              }}>
                <img src="/images/profile-avatar.png" alt="No applicant" style={{ width: '80px', height: '80px', opacity: 0.5, marginBottom: '24px' }} />
                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px', color: '#333' }}>
                  No applicant selected
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '16px', color: '#666', lineHeight: 1.5, maxWidth: '400px' }}>
                  Select an applicant from the list to view their profile details and specializations
                </Typography>
              </Box>
            ) : (
              <Box sx={{ backgroundColor: "#fff" }}>
                {userVideos?.length ? (
                  <>
                    {/* Main Video Player */}
                    <Box sx={{ position: 'relative', backgroundColor: '#000', marginBottom: '16px' }}>
                      {userVideos?.length && userVideos[currentActive] ? (
                        <ReactPlayer
                          height={450}
                          url={userVideos[currentActive]?.videoPath}
                          width="100%"
                          controls
                          playing={false}
                        />
                      ) : (
                        <Box sx={{
                          height: 450,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          color: '#666'
                        }}>
                          <img src="/images/video-icon.png" alt="No video" style={{ width: '64px', height: '64px', opacity: 0.5, marginBottom: '16px' }} />
                          <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px' }}>
                            No video selected
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: '16px', color: '#999', textAlign: 'center' }}>
                            Select an applicant to view their video responses
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Video Description */}
                    {userVideos?.length && userVideos[currentActive] && (
                      <>
                        <Box sx={{ padding: '8px 16px' }}>
                          <Typography variant="h6" fontSize={"14px"} sx={{ fontWeight: '600', marginBottom: '2px', lineHeight: 1.2 }}>
                            {userVideos[currentActive]?.topic || "About You"}
                          </Typography>
                          <Typography variant="body2" fontSize={"12px"} sx={{ color: '#666', lineHeight: 1.3 }}>
                            {userVideos[currentActive]?.question || "What do you think is your most unique trait and characteristics?"}
                          </Typography>
                        </Box>
                        <Divider />
                      </>
                    )}

                    {/* Video List - Horizontal Scrollable Thumbnails */}
                    <Box sx={{ padding: '16px' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '16px',
                          overflowX: 'auto',
                          paddingBottom: '8px',
                          '&::-webkit-scrollbar': {
                            height: '6px',
                          },
                          '&::-webkit-scrollbar-track': {
                            backgroundColor: '#f1f1f1',
                            borderRadius: '3px',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#756DE9',
                            borderRadius: '3px',
                          },
                          '&::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#5f5bc4',
                          },
                        }}
                      >
                        {userVideos?.map((el: any, index: number) => (
                          <Box
                            key={index}
                            sx={{
                              cursor: 'pointer',
                              flex: userVideos.length <= 3 ? 1 : 'none',
                              minWidth: userVideos.length <= 3 ? 'auto' : '120px',
                              maxWidth: userVideos.length <= 3 ? 'none' : '120px',
                              borderRadius: '12px',
                              backgroundColor: currentActive === index ? '#E8E4FF' : '#F8F9FA',
                              border: currentActive === index ? '2px solid #756DE9' : '1px solid #E0E0E0',
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              '&:hover': {
                                backgroundColor: currentActive === index ? '#E8E4FF' : '#F0F0F0',
                                border: currentActive === index ? '2px solid #756DE9' : '1px solid #D6D0FF',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                              }
                            }}
                            onClick={() => handleVideoClick(index, el?.questionId)}
                          >
                            {/* Video Thumbnail Only */}
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                aspectRatio: '1 / 1.3',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#f5f5f5',
                                border: '1px solid #E0E0E0'
                              }}
                            >
                              <VideoThumbnail videoUrl={el?.videoPath} />
                              {currentActive === index && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    borderRadius: '50%',
                                    width: '28px',
                                    height: '28px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <img src="/images/Vector-play.png" width="14px" height="14px" alt="Playing" />
                                </Box>
                              )}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </>
                ) : (
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '200px',
                    flexDirection: 'column',
                    gap: '16px'
                  }}>
                    {selectedApplicant ? (
                      <>
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          No videos available for this applicant
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Videos will appear here once the applicant uploads them
                        </Typography>
                      </>
                    ) : (
                      <>
                        <img src="/images/video-icon.png" alt="No video" style={{ width: '48px', height: '48px', opacity: 0.5 }} />
                        <Typography sx={{ color: '#666', fontSize: '16px' }}>
                          Select an applicant to view videos
                        </Typography>
                        <Typography sx={{ color: '#999', fontSize: '14px' }}>
                          Choose an applicant from the list to see their video responses
                        </Typography>
                      </>
                    )}
                  </Box>
                )}
              </Box>
            )}
          </Box>
          {/* Content for section 2 */}
        </Box>

        {/* Section 3 - Right */}
        <Box sx={{
          flex: 2,
          minHeight: 0,
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          <Tabs
            value={activeTab1}
            onChange={handleTabChange1}
            TabIndicatorProps={{
              style: { backgroundColor: "#756de9", height: "2px", borderRadius: "2px" }, // Adjust this as needed
            }}
            variant="fullWidth"
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              backgroundColor: "white",
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              "& .MuiTab-root": {
                fontSize: "14px",
                fontWeight: "500",
                color: "#000",
              },
              "& .Mui-selected": {
                color: "#756de9", // Change color of the selected tab text
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#756de9 !important", // Ensure the indicator is visible
              },
            }}
          >
            <Tab label="PROFILE DETAILS" sx={{ fontSize: "14px", weight: "500", color: "#000" }} />
            <Tab label="SPECIALIZATION" sx={{ fontSize: "14px", weight: "500", color: "#000" }} />
            <Tab label="PERSONALITY" sx={{ fontSize: "14px", weight: "500", color: "#000" }} />
          </Tabs>

          {/* Content area that will grow */}
          <Box sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
            paddingBottom: profileId ? '8px' : '60px', // Less padding for share view
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#fafafa", // very light grey
              borderRadius: "4px",
            },
          }}>
            {loadingApplicantDetails ? (
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%',
                backgroundColor: "#fff"
              }}>
                <CircularProgress size={40} />
                <Typography sx={{ ml: 2, color: '#666' }}>Loading profile details...</Typography>
              </Box>
            ) : !selectedApplicant ? (
              // Show placeholder when no applicant is selected
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                padding: '60px 40px',
                textAlign: 'center',
                backgroundColor: "#fff"
              }}>
                <img src="/images/profile-avatar.png" alt="No applicant" style={{ width: '80px', height: '80px', opacity: 0.5, marginBottom: '24px' }} />
                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px', color: '#333' }}>
                  No applicant selected
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '16px', color: '#666', lineHeight: 1.5, maxWidth: '400px' }}>
                  Select an applicant from the list to view their profile details and specializations
                </Typography>
              </Box>
            ) : (
              <>
                {/* Profile Details Content */}
            {activeTab1 === 0 && (
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "8px",
                  textAlign: "center",
                  borderRadius: "10px",
                }}
              >
                <Box style={{ padding: "2px", marginBottom: "10px" }} className="">
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", textAlign: "left" }}>
                    Demographics
                  </Typography>

                  <Stack style={{ marginTop: "10px" }} direction="column" spacing={1}>
                    <Stack direction="row" spacing={1}>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "33%" }}
                      >
                        <img src="/images/dob.png" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {moment(dob).format("DD/MM/YYYY")}
                        </Typography>
                      </Stack>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "33%" }}
                      >
                        <img src="/images/location.png" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {city}
                        </Typography>
                      </Stack>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "33%" }}
                      >
                        <img src="/images/complete-profile/Gender.svg" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {gender || '—'}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "50%" }}
                      >
                        <img src="/images/language.png" width="20px"></img>
                        <Typography style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
                          {languages?.join(", ")}
                        </Typography>
                      </Stack>
                      {userExperience?.length > 1 ? (
                        <Stack
                          direction="column"
                          spacing={1}
                          sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "50%" }}
                        >
                          <img src="/images/client-website/id-image.png" width="20px"></img>
                          <Typography
                            style={{ color: "#222222", fontSize: "14px", fontWeight: "400", textAlign: "left" }}
                          >
                            Currently Working
                          </Typography>
                        </Stack>
                      ) : null}
                    </Stack>
                  </Stack>
                </Box>
                <Box style={{ padding: "2px", marginBottom: "10px" }} className="">
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", textAlign: "left" }}>
                    Education
                  </Typography>

                  <Grid container spacing={2} style={{ marginTop: "-5px" }}>
                    {educationDetails?.map((el: any, id: any) => {
                      return (
                        <Grid item xs={6} key={id}>
                          <Stack
                            direction="column"
                            spacing={0.5}
                            sx={{
                              border: "1px solid #C4C4C44D",
                              borderRadius: "5px",
                              padding: "10px",
                            }}
                          >
                            <Typography
                              style={{ color: "#222222", fontSize: "14px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.educationType === "Board" ? el?.board : el?.courseName}
                            </Typography>
                            <Typography
                              style={{ color: "#1F2235", fontSize: "12px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.educationType === "Board" ? el?.schoolName : el?.institutionName}
                            </Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <img src="/images/Calendar-new.png" width="20px" />
                              <Typography
                                style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                              >
                                {el?.yetToGraduate
                                  ? `Studying since ${el?.startDate}`
                                  : el?.startDate &&
                                  `${calculateYears(el.startDate, el.endDate)}, ${el.startDate} - ${el.endDate || "Present"
                                  }`}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
                <Box style={{ padding: "2px", marginBottom: "10px" }} className="">
                  <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550", textAlign: "left" }}>
                    Experiences
                  </Typography>
                  {userExperience?.map((el: any, id: any) => {
                    return (
                      <Stack key={id} style={{ marginTop: "10px" }} direction="column" spacing={1}>
                        <Stack direction="row" spacing={1}>
                          <Stack
                            direction="column"
                            spacing={0.5}
                            sx={{ border: "1px solid #C4C4C44D", borderRadius: "5px", padding: "10px", width: "100%" }}
                          >
                            <Typography
                              style={{ color: "#222222", fontSize: "14px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.companyName}
                            </Typography>
                            <Typography
                              style={{ color: "#1F2235", fontSize: "12px", fontWeight: "500", textAlign: "left" }}
                            >
                              {el?.designationName}
                            </Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <img src="/images/client-website/people-icon.png" width="20px"></img>
                              <Typography
                                style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                              >
                                {el?.departmentName}
                              </Typography>
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <img src="/images/Calendar-new.png" width="20px"></img>
                              <Typography
                                style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                              >
                                {!el?.endDate
                                  ? `${moment(el?.startDate).format("DD/MM/YYYY")} - Currently Working Here`
                                  : `${moment(el?.startDate).format("DD/MM/YYYY")} - ${moment(el?.endDate).format(
                                    "DD/MM/YYYY"
                                  )}`}
                              </Typography>
                            </Stack>
                            {el?.workLink && (
                              <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ width: "100%" }}>
                                <img src="/images/link.png" style={{ width: "20px", flexShrink: 0, marginTop: 2 }} alt="Link" />
                                <Box
                                  component="a"
                                  href={el.workLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{
                                    minWidth: 0,
                                    flex: 1,
                                    color: "#1976d2",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    textDecoration: "underline",
                                    textAlign: "left",
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {el.workLink}
                                </Box>
                              </Stack>
                            )}
                            <Typography
                              style={{ color: "#555555", fontSize: "12px", fontWeight: "400", textAlign: "left" }}
                            >
                              {el?.description}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    );
                  })}
                </Box>
              </Box>
            )}

            {/* Specialization Content */}
            {activeTab1 === 1 && (
              <Box style={{ borderRadius: "10px", padding: "8px", marginBottom: "10px" }} className="">
                <Box
                  sx={{
                    borderRadius: "10px",
                    border: "1px solid #B7B3EB",
                    padding: "2px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "#e5e3fd",
                      height: "20px",
                      padding: "10px",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550" }}>
                      Skill Set
                    </Typography>
                  </Stack>
                  <Stack style={{ padding: "10px" }} direction="column">
                    {skills && skills.length > 0 ? (
                      <Typography style={{ color: "#555555", fontSize: "14px" }}>
                        {skills.map((tool: string, index: number) => (
                          <React.Fragment key={index}>
                            <span>{tool}</span>
                            {index !== skills.length - 1 && <span style={{ color: "orange" }}> | </span>}
                          </React.Fragment>
                        ))}
                      </Typography>
                    ) : (
                      <Typography style={{ color: "#999999", fontSize: "14px", fontStyle: "italic" }}>
                        No skills added yet
                      </Typography>
                    )}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderRadius: "10px",
                    border: "1px solid #B7B3EB",
                    padding: "2px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "#e5e3fd",
                      height: "20px",
                      padding: "10px",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550" }}>
                      Tools Known
                    </Typography>
                  </Stack>
                  <Stack style={{ padding: "10px" }} direction="column">
                    {tools && tools.length > 0 ? (
                      <Typography style={{ color: "#555555", fontSize: "14px" }}>
                        {tools.map((tool: string, index: number) => (
                          <React.Fragment key={index}>
                            <span>{tool}</span>
                            {index !== tools.length - 1 && <span style={{ color: "orange" }}> | </span>}
                          </React.Fragment>
                        ))}
                      </Typography>
                    ) : (
                      <Typography style={{ color: "#999999", fontSize: "14px", fontStyle: "italic" }}>
                        No tools known yet
                      </Typography>
                    )}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderRadius: "10px",
                    border: "1px solid #B7B3EB",
                    padding: "2px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "#e5e3fd",
                      height: "20px",
                      padding: "10px",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550" }}>Work link</Typography>
                  </Stack>
                  <Stack style={{ padding: "10px" }} direction="column">
                    {resolvedShareWorkLinks.length ? (
                      <Stack direction="column" spacing={0.75}>
                        {resolvedShareWorkLinks.map((wl: string, i: number) => (
                          <Link
                            key={`${wl}-${i}`}
                            href={formatShareWorkLinkHref(wl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ fontSize: "14px", color: "#756DE9", wordBreak: "break-all" }}
                          >
                            {wl}
                          </Link>
                        ))}
                      </Stack>
                    ) : (
                      <Typography style={{ color: "#999999", fontSize: "14px", fontStyle: "italic" }}>
                        Not added
                      </Typography>
                    )}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderRadius: "10px",
                    border: "1px solid #B7B3EB",
                    padding: "2px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "#e5e3fd",
                      height: "20px",
                      padding: "10px",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography style={{ color: "#000000", fontSize: "14px", fontWeight: "550" }}>
                      Certifications
                    </Typography>
                  </Stack>
                  <Stack style={{ padding: "10px" }} direction="column">
                    {userCertificates && userCertificates.length > 0 ? (
                      userCertificates.map((el: any, index: number) => {
                        return (
                          <React.Fragment key={index}>
                            <Typography
                              style={{
                                color: "#000000",
                                fontSize: "14px",
                                fontWeight: "550",
                                margin: "10px 0px",
                              }}
                            >
                              {el?.certificateName}
                            </Typography>

                            <Stack direction="column" spacing={1}>
                              <Stack direction="row" spacing={1}>
                                <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                  {el?.institute}
                                </Typography>
                              </Stack>
                              <Stack direction="row" spacing={1}>
                                <img src="/images/Calendar-new.png" width="20px"></img>
                                <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                  Duration: {el?.courseDuration && formatDuration(el.courseDuration)}
                                </Typography>
                              </Stack>
                              {el?.courseExpiry ? (
                                <Stack direction="row" spacing={1}>
                                  <img src="/images/complete-profile/Course Expiry Date.svg" width="20px"></img>
                                  <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                    Certification Expiry Date: {moment(el?.courseExpiry)?.format("DD/MM/YYYY")}
                                  </Typography>
                                </Stack>
                              ) : null}

                              {el?.certificateReceived && (
                                <Stack direction="row" spacing={1}>
                                  <img src="/images/Tick.png" width="20px"></img>
                                  <Typography style={{ color: "#555555", fontSize: "14px", fontWeight: "550" }}>
                                    Received Certificate
                                  </Typography>
                                </Stack>
                              )}
                              {index < userCertificates.length - 1 && <Divider sx={{ mt: 2, mb: 1 }} variant="middle" />}
                            </Stack>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <Typography style={{ color: "#999999", fontSize: "14px", fontStyle: "italic" }}>
                        No certifications added yet
                      </Typography>
                    )}
                  </Stack>
                </Box>
              </Box>
            )}

            {activeTab1 === 2 && (
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "left", padding: "8px" }}>
                <img src="/images/connector-image.png" alt="Connector" width="150px" />
                <Typography style={{ fontSize: "18px", fontWeight: "600", color: "#1F2235", marginTop: "10px" }}>
                  {!userPersonality || userPersonality.length === 0
                    ? "Well Balanced Personality"
                    : userPersonality
                        .map((el: any) => el?.displayPersonalityType)
                        .reduce((acc: string[], curr: string, index: number, arr: string[]) => {
                          if (arr.length === 2 && index === 1) {
                            return [...acc, "and " + curr];
                          }
                          if (index === arr.length - 1 && arr.length > 1) {
                            return [...acc, "and " + curr];
                          }
                          return [...acc, curr];
                        }, [])
                        .join(userPersonality.length === 2 ? " " : ", ")}
                </Typography>
                <Typography style={{ fontSize: "14px", fontWeight: "400", color: "#1F2235", marginTop: "10px" }}>
                  {userPersonality
                    ?.map((el: any) => el?.typeDescriptors)
                    .join("\n")
                    .split("\n")
                    .map((line: any, index: any) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                </Typography>

                <Button
                  onClick={toggleReportView}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#756DE9",
                    cursor: "pointer",
                    gap: 1,
                    mt: 2,
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "1px solid #756DE9",
                    backgroundColor: "transparent",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#F8F7FF",
                      border: "1px solid #756DE9",
                    },
                  }}
                >
                  View Full Report <ArrowForward sx={{ fontSize: "18px" }} />
                </Button>

                <Divider sx={{ marginTop: "20px", marginBottom: "20px" }}></Divider>
              </Box>
            )}
              </>
            )}
          </Box>

          {/* Button section at bottom - show for share profile (all scenarios), candidate profile, and regular view */}
          <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "#1F2235",
                borderRadius: "0px 0px 8px 8px",
                bgcolor: "#1F2235",
                py: profileId ? 0.5 : 1,
                height: profileId ? "auto" : "30px",
                marginTop: "auto",
                minHeight: profileId ? "40px" : "30px",
              }}
            >
              {profileId ? (
                // Share / candidate profile view - Show Reach Out in all scenarios (logged in or not)
                <>
                  <Button
                    onClick={handleOpenModal}
                    sx={{ fontSize: "14px", weight: "400", color: "#fff", textAlign: "center", width: "100%" }}
                  >
                    Reach Out{" "}
                    <img
                      src="/images/client-website/reach-out.png"
                      width="15px"
                      height="15px"
                      style={{ marginLeft: "8px" }}
                    ></img>
                  </Button>
                </>
            ) : (
              // Regular view - Show all buttons
              <>
                <Button
                  onClick={handleShortlistAction}
                  disabled={loadingShortlist}
                  sx={{ 
                    fontSize: "14px", 
                    weight: "400", 
                    color: "#fff", 
                    textAlign: "center", 
                    width: "50%",
                    opacity: loadingShortlist ? 0.7 : 1,
                    "&:disabled": {
                      color: "#fff",
                    }
                  }}
                >
                  {loadingShortlist ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CircularProgress size={14} sx={{ color: '#fff' }} />
                      <Typography sx={{ fontSize: '14px' }}>
                        {selectedApplicantDetails?.applicationStatus === "SHORTLIST" ? "Updating..." : "Shortlisting..."}
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {selectedApplicantDetails?.applicationStatus === "SHORTLIST" 
                        ? (activeApplicantsTab === 1 
                            ? (() => {
                                console.log('Shortlist tab - isPrimary:', selectedApplicantDetails?.isPrimary);
                                return selectedApplicantDetails?.isPrimary ? "Secondary List" : "Primary List";
                              })()
                            : "Shortlisted") 
                        : "Shortlist"}{" "}
                      <img
                        src={(() => {
                          let iconPath = "";
                          if (selectedApplicantDetails?.applicationStatus === "SHORTLIST") {
                            if (activeApplicantsTab === 1) {
                              // In shortlist tab
                              iconPath = selectedApplicantDetails?.isPrimary ? "/images/down-arrow.svg" : "/images/up-arrow.svg";
                            } else {
                              // In applied tab
                              iconPath = "/images/Group.png";
                            }
                          } else {
                            // Not shortlisted
                            iconPath = "/images/outlined-heart.svg";
                          }
                          console.log('Selected icon path:', iconPath);
                          return iconPath;
                        })()}
                        width="17px"
                        height="17px"
                        style={{ marginLeft: "8px" }}
                      />
                    </>
                  )}
                </Button>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ marginLeft: 2, marginRight: 2, height: "24px", backgroundColor: "#ffffff", marginTop: "6px" }}
                />
                <Button
                  onClick={handleOpenModal}
                  sx={{ fontSize: "14px", weight: "400", color: "#fff", textAlign: "center", width: "50%" }}
                >
                  Reach Out{" "}
                  <img
                    src="/images/client-website/reach-out.png"
                    width="15px"
                    height="15px"
                    style={{ marginLeft: "8px" }}
                  ></img>
                </Button>
              </>
            )}
            </Box>

            {/* Modal Component */}
            <Modal open={openModal} onClose={handleCloseModal}>
              <Box sx={styles.modalContent}>
                <Typography variant="h6" component="h2">
                  Reach out to the candidate
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid #756DE9",
                    borderRadius: "10px",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Box
                    sx={{ display: "flex", flexDirection: "row", padding: "10px", borderRadius: "10px", width: "50%" }}
                  >
                    <Grid sx={{ display: "flex", flexDirection: "row", padding: "10px", borderRadius: "10px" }}>
                      <img src={selectedApplicantDetails?.profilePicturePath} width="50px" height="50px"></img>
                      <Grid sx={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                        <Typography sx={{ fontSize: "13px", color: "#000105", fontWeight: "400" }}>
                          {selectedApplicantDetails?.fullName}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#B56E00",
                            fontWeight: "600",
                            backgroundColor: "#EDCD5A5E;",
                            padding: "2px 5px",
                            borderRadius: "100px",
                          }}
                        >
                          {selectedApplicantDetails?.applicationStatus}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box>
                    <Box sx={{ display: "flex", flexDirection: "column", alignContent: "center", gap: 1 }}>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <img src="/images/Call-icon.png" width="20"></img>
                        <a style={{ textDecoration: "none", color: "#756DE9" }} href={`tel:${phoneNumber}`}>
                          {phoneNumber}
                        </a>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <img src="/images/Email_icon.png" width="20" height="18"></img>
                        <a
                          style={{ textDecoration: "none", color: "#756DE9", fontSize: "16px", fontWeight: "400" }}
                          href={`mailto:${email}`}
                        >
                          {email}
                        </a>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Divider sx={{ marginY: 2 }} />
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                  <Button
                    onClick={handleCloseModal}
                    variant="contained"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "99px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      width: "12%",
                      color: "#000000",
                      padding: "10px 50px",
                      "&:hover ": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleJobAction("ACCEPTED")}
                    disabled={loadingReachout}
                    sx={{
                      backgroundColor: "#756DE9",
                      color: "#fff",
                      borderRadius: "50px",
                      padding: "10px 40px",
                      opacity: loadingReachout ? 0.7 : 1,
                      "&:hover": {
                        backgroundColor: "#756DE9", // Keep the same background color on hover
                      },
                      "&:disabled": {
                        backgroundColor: "#756DE9",
                        color: "#fff",
                      },
                    }}
                  >
                    {loadingReachout ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={16} sx={{ color: '#fff' }} />
                        <Typography sx={{ fontSize: '16px' }}>Processing...</Typography>
                      </Box>
                    ) : (
                      "Done"
                    )}
                  </Button>
                </Box>
              </Box>
            </Modal>

            {/* <Divider
              orientation="vertical"
              flexItem
              sx={{ marginLeft: 2, marginRight: 2, height: "24px", backgroundColor: "#ffffff", marginTop: "6px" }}
            />
            <Button
              onClick={handleOpenModalDecline}
              sx={{ 
                fontSize: "14px", 
                weight: "400", 
                color: selectedApplicantDetails?.applicationStatus === "DECLINED" ? "#4CAF50" : "#FD794B", 
                textAlign: "center", 
                width: "50%" 
              }}
            >
              {selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept" : "Decline"}{" "}
              <img
                src={selectedApplicantDetails?.applicationStatus === "DECLINED" ? "/images/tick-new.png" : "/images/client-website/reject.png"}
                width="12px"
                height="12px"
                style={{ marginLeft: "8px" }}
                alt={selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept" : "Decline"}
              ></img>
            </Button> */}

            {/* Modal Component */}
            <Modal open={openModalDecline} onClose={handleCloseModalDecline}>
              <Box sx={styles.modalContentDecline}>
                <Typography variant="h6" component="h2">
                  {selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept candidate" : "Decline candidate"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #756DE9",
                  }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "row", padding: "10px", borderRadius: "10px" }}>
                    <img src={selectedApplicantDetails?.profilePicturePath} width="50px" height="50px"></img>
                    <Grid sx={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                      <Typography sx={{ fontSize: "13px", color: "#000105", fontWeight: "400" }}>
                        {selectedApplicantDetails?.fullName}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#B56E00",
                          fontWeight: "600",
                          backgroundColor: "#EDCD5A5E;",
                          padding: "2px 5px",
                          borderRadius: "100px",
                        }}
                      >
                        {selectedApplicantDetails?.applicationStatus}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Divider sx={{ marginY: 2 }} />

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, }}>
                  <Button
                    onClick={handleCloseModalDecline}
                    variant="contained"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "99px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      width: "12%",
                      color: "#000000",
                      padding: "10px 50px",
                      "&:hover ": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleJobAction(selectedApplicantDetails?.applicationStatus === "DECLINED" ? "APPLIED" : "DECLINED")}
                    disabled={loadingDecline}
                    sx={{
                      backgroundColor: "#756DE9",
                      color: "#fff",
                      borderRadius: "50px",
                      padding: "10px 40px",
                      opacity: loadingDecline ? 0.7 : 1,
                      "&:hover": {
                        backgroundColor: "#756DE9", // Keep the same background color on hover
                      },
                      "&:disabled": {
                        backgroundColor: "#756DE9",
                        color: "#fff",
                      },
                    }}
                  >
                    {loadingDecline ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={16} sx={{ color: '#fff' }} />
                        <Typography sx={{ fontSize: '16px' }}>
                          {selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accepting..." : "Declining..."}
                        </Typography>
                      </Box>
                    ) : (
                      selectedApplicantDetails?.applicationStatus === "DECLINED" ? "Accept" : "Decline"
                    )}
                  </Button>
                </Box>
              </Box>
            </Modal>

            {/* Best Fit Modal Component */}
            {canShowBestFit() && (
            <Modal
              open={openBestFitModal}
              onClose={toggleBestFitModal}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "16px" : "20px",
              }}
            >
              <Box sx={{
                position: "relative",
                width: isMobile ? "calc(100vw - 32px)" : "450px",
                maxWidth: isMobile ? "400px" : "450px",
                maxHeight: isMobile ? "calc(100vh - 32px)" : "auto",
                backgroundColor: "white",
                borderRadius: isMobile ? "12px" : "16px",
                padding: isMobile ? "20px" : "24px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
                outline: "none",
                overflow: "auto",
              }}>
                {/* Header with icon */}
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: isMobile ? "16px" : "20px",
                  flexDirection: isMobile ? "column" : "row",
                  textAlign: isMobile ? "center" : "left",
                }}>
                  <Box sx={{
                    width: isMobile ? "40px" : "48px",
                    height: isMobile ? "40px" : "48px",
                    borderRadius: "50%",
                    backgroundColor: "#E8F5E8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: isMobile ? "0" : "16px",
                    marginBottom: isMobile ? "12px" : "0",
                  }}>
                    <img src="/images/Tick.png" width={isMobile ? "20px" : "24px"} height={isMobile ? "20px" : "24px"} alt="Best Fit" />
                  </Box>
                  <Typography variant="h5" component="h2" sx={{
                    fontSize: isMobile ? "18px" : "20px",
                    fontWeight: "600",
                    color: "#1F2235",
                    margin: 0,
                  }}>
                    {selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'}
                  </Typography>
                </Box>

                {/* Description */}
                <Typography sx={{
                  fontSize: isMobile ? "13px" : "14px",
                  color: "#666666",
                  marginBottom: isMobile ? "16px" : "20px",
                  lineHeight: 1.5,
                  textAlign: isMobile ? "center" : "left",
                }}>
                  {selectedApplicantDetails?.isBestFit 
                    ? 'Are you sure you want to remove this candidate from the best fit status? This action will remove their top choice highlight.'
                    : 'Are you sure you want to mark this candidate as the best fit for this position? This action will highlight them as your top choice.'
                  }
                </Typography>

                {/* Candidate Info */}
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: isMobile ? "12px" : "16px",
                  borderRadius: "12px",
                  backgroundColor: "#F8F9FA",
                  border: "1px solid #E8F5E8",
                  marginBottom: isMobile ? "20px" : "24px",
                }}>
                  <img
                    src={profilePicturePath || selectedApplicantDetails?.profilePicturePath}
                    width={isMobile ? "40px" : "50px"}
                    height={isMobile ? "40px" : "50px"}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                    alt="Candidate"
                  />
                  <Box sx={{ marginLeft: isMobile ? "10px" : "12px", flex: 1 }}>
                    <Typography sx={{
                      fontSize: isMobile ? "14px" : "16px",
                      color: "#1F2235",
                      fontWeight: "500",
                      marginBottom: "4px",
                    }}>
                      {selectedApplicantDetails?.fullName}
                    </Typography>
                    <Box sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      fontSize: isMobile ? "11px" : "12px",
                      fontWeight: "600",
                    }}>
                      <img src="/images/Tick.png" width="12px" height="12px" style={{ marginRight: "4px" }} />
                      BEST FIT CANDIDATE
                    </Box>
                  </Box>
                </Box>

                {/* Action Buttons */}
                <Box sx={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-end",
                  gap: isMobile ? "8px" : "12px",
                  flexDirection: isMobile ? "column" : "row",
                }}>
                  <Button
                    onClick={toggleBestFitModal}
                    disabled={loadingBestFit}
                    variant="outlined"
                    fullWidth={isMobile}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      fontSize: isMobile ? "15px" : "14px",
                      fontWeight: "500",
                      color: "#666666",
                      padding: isMobile ? "12px 24px" : "10px 24px",
                      textTransform: "none",
                      minHeight: isMobile ? "48px" : "auto",
                      opacity: loadingBestFit ? 0.7 : 1,
                      "&:hover": {
                        borderColor: "#CCCCCC",
                        backgroundColor: "#F5F5F5",
                      },
                      "&:disabled": {
                        borderColor: "#E0E0E0",
                        color: "#666666",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleBestFitAction}
                    disabled={loadingBestFit}
                    fullWidth={isMobile}
                    sx={{
                      backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                      color: "#fff",
                      borderRadius: "8px",
                      fontSize: isMobile ? "15px" : "14px",
                      fontWeight: "500",
                      padding: selectedApplicantDetails?.isBestFit ? (isMobile ? "12px 32px" : "10px 32px") : (isMobile ? "12px 24px" : "10px 24px"),
                      minWidth: selectedApplicantDetails?.isBestFit ? (isMobile ? "200px" : "180px") : "auto",
                      textTransform: "none",
                      minHeight: isMobile ? "48px" : "auto",
                      opacity: loadingBestFit ? 0.7 : 1,
                      "&:hover": {
                        backgroundColor: selectedApplicantDetails?.isBestFit ? "#d32f2f" : "#45a049",
                      },
                      "&:disabled": {
                        backgroundColor: selectedApplicantDetails?.isBestFit ? "#f44336" : "#4CAF50",
                        color: "#fff",
                      },
                    }}
                  >
                    {loadingBestFit ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={isMobile ? 18 : 16} sx={{ color: '#fff' }} />
                        <Typography sx={{ fontSize: isMobile ? '15px' : '14px' }}>
                          {selectedApplicantDetails?.isBestFit ? 'Removing...' : 'Marking...'}
                        </Typography>
                      </Box>
                    ) : (
                      selectedApplicantDetails?.isBestFit ? 'Remove from Best Fit' : 'Mark as Best Fit'
                    )}
                  </Button>
                </Box>
              </Box>
            </Modal>
            )}
          </Box>
        </Box>
      </Box>
  );

  // Return appropriate content based on mobile/desktop
  if (isMobile) {
    return (
      <>
        {mobileContent}
        <Modal open={openModal} onClose={handleCloseModal} BackdropProps={{ sx: { zIndex: 1400 } }} sx={{ zIndex: 1400 }}>
          <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "calc(100% - 48px)", maxWidth: "400px", backgroundColor: "white", borderRadius: "16px", padding: "24px", boxShadow: 24, zIndex: 1401, outline: "none" }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Reach out to the candidate</Typography>
            {phoneNumber && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <img src="/images/Call-icon.png" width="20" height="20" alt="" />
                <a style={{ textDecoration: "none", color: "#756DE9", fontSize: "16px" }} href={`tel:${phoneNumber}`}>{phoneNumber}</a>
              </Box>
            )}
            {email && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <img src="/images/Email_icon.png" width="20" height="18" alt="" />
                <a style={{ textDecoration: "none", color: "#756DE9", fontSize: "16px" }} href={`mailto:${email}`}>{email}</a>
              </Box>
            )}
            {!phoneNumber && !email && <Typography sx={{ color: "#666", fontSize: "14px" }}>No contact details available.</Typography>}
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button onClick={handleCloseModal} variant="outlined" sx={{ borderRadius: "8px", textTransform: "none" }}>Cancel</Button>
              <Button onClick={() => handleJobAction("ACCEPTED")} disabled={loadingReachout} variant="contained" sx={{ backgroundColor: "#756DE9", color: "#fff", borderRadius: "8px", textTransform: "none", opacity: loadingReachout ? 0.7 : 1 }}>
                {loadingReachout ? <><CircularProgress size={16} sx={{ color: "#fff" }} /> Done</> : "Done"}
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* More candidates bottom sheet (share profile mobile) */}
        <Drawer
          anchor="bottom"
          open={candidateOverflowOpen}
          onClose={handleCloseCandidateOverflow}
          PaperProps={{
            sx: {
              borderTopLeftRadius: '20px',
              borderTopRightRadius: '20px',
              maxHeight: '60vh',
            },
          }}
        >
          <Box sx={{ p: 2.5, pb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#1F2235' }}>
                More candidates
              </Typography>
              <IconButton onClick={handleCloseCandidateOverflow} size="small" aria-label="Close">
                <CloseIcon />
              </IconButton>
            </Box>
            <TextField
              fullWidth
              size="small"
              placeholder="Search candidates..."
              value={overflowSearchQuery}
              onChange={(e) => setOverflowSearchQuery(e.target.value)}
              sx={{
                mb: 2,
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F4F3FF',
                  borderRadius: '8px',
                  '& fieldset': {
                    border: '1px solid rgba(117,109,233,0.25)',
                  },
                  '&:hover fieldset': {
                    border: '1px solid rgba(117,109,233,0.45)',
                  },
                  '&.Mui-focused fieldset': {
                    border: '1px solid #756DE9',
                  },
                },
                '& .MuiInputBase-input': {
                  color: '#1F2235',
                  fontSize: '14px',
                  '&::placeholder': {
                    color: 'rgba(31,34,53,0.45)',
                    opacity: 1,
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src="/images/search.svg" width="16px" height="16px" alt="Search" />
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, overflowY: 'auto', maxHeight: 'calc(60vh - 140px)' }}>
              {overflowSheetApplicants.length > 0 ? (
                overflowSheetApplicants.map((applicant: any) => {
                const isSelected =
                  String(selectedUserId || selectedApplicant) === String(applicant.userId);
                return (
                  <Box
                    key={applicant.userId}
                    onClick={() => {
                      handleUserSelection(applicant.userId);
                      handleCloseCandidateOverflow();
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      p: 1.25,
                      borderRadius: '10px',
                      cursor: 'pointer',
                      bgcolor: isSelected ? 'rgba(117, 109, 233, 0.12)' : 'transparent',
                      '&:hover': { bgcolor: 'rgba(117, 109, 233, 0.08)' },
                    }}
                  >
                    <Avatar src={applicant.profilePicturePath || profileImage} sx={{ width: 40, height: 40 }} />
                    <Typography sx={{ fontSize: 15, fontWeight: isSelected ? 600 : 400, color: '#1F2235' }}>
                      {applicant.fullName}
                    </Typography>
                  </Box>
                );
              })
              ) : (
                <Typography sx={{ color: 'rgba(31,34,53,0.5)', fontSize: 14, fontStyle: 'italic', textAlign: 'center', py: 2 }}>
                  No candidates found
                </Typography>
              )}
            </Box>
          </Box>
        </Drawer>
        {/* Comment Popup */}
        <CommentPopup
          open={openCommentModal}
          onClose={toggleCommentModal}
          jobId={jobId ? parseInt(jobId) : undefined}
          receiverId={selectedApplicantDetails?.userId}
        />
        {/* Password Modal */}
        <Dialog 
          open={openPasswordModal} 
          onClose={() => {
            // Prevent closing without password
            console.log('Password modal close attempted');
          }}
          fullScreen={isMobile}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown={true}
          PaperProps={{
            sx: {
              borderRadius: isMobile ? 0 : "16px",
              padding: isMobile ? "24px" : "32px",
              margin: isMobile ? 0 : "32px",
              maxWidth: isMobile ? "100%" : "400px",
              zIndex: 1300,
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1299,
            },
          }}
          sx={{
            zIndex: 1300,
          }}
        >
          <Box sx={{
            width: "100%",
            backgroundColor: "white",
            outline: "none",
          }}>
            <Box sx={{ textAlign: "center", marginBottom: isMobile ? "20px" : "24px" }}>
              <Box sx={{ 
                width: isMobile ? "40px" : "48px", 
                height: isMobile ? "40px" : "48px", 
                backgroundColor: "#F5F5F5", 
                borderRadius: "50%", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center", 
                margin: "0 auto 16px auto",
                border: "2px solid #E0E0E0"
              }}>
                <Typography sx={{ fontSize: isMobile ? "20px" : "24px", color: "#666" }}>🔒</Typography>
              </Box>
              <Typography variant={isMobile ? "h6" : "h5"} sx={{ color: "#1F2235", fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "18px" : undefined }}>
                Password Required
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", fontSize: isMobile ? "13px" : undefined }}>
                This share link is password protected. Please enter the password to continue.
              </Typography>
            </Box>

            <TextField
              fullWidth
              type="password"
              label="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(''); // Clear error when user types
              }}
              error={!!passwordError}
              helperText={passwordError}
              sx={{
                marginBottom: isMobile ? "20px" : "24px",
                '& .MuiOutlinedInput-root': {
                  borderRadius: "999px",
                  backgroundColor: passwordError ? "rgba(211, 47, 47, 0.02)" : "rgba(75, 68, 212, 0.02)",
                  boxShadow: passwordError ? "inset 0px 0px 11px 2px rgba(211, 47, 47, 0.08)" : "inset 0px 0px 11px 2px rgba(75, 68, 212, 0.08)",
                  fontFamily: "DM Sans",
                  fontSize: "14px",
                  fontWeight: 400,
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
                "& .MuiInputLabel-root": {
                  fontFamily: "DM Sans",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: passwordError ? "#d32f2f" : "#666",
                },
                "& .MuiFormHelperText-root": {
                  fontFamily: "DM Sans",
                  fontSize: "12px",
                  marginTop: "4px",
                },
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !isValidatingPassword) {
                  handlePasswordSubmit();
                }
              }}
            />

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={handlePasswordSubmit}
                disabled={!password.trim() || isValidatingPassword}
                sx={{
                  backgroundColor: "#756DE9",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  padding: "10px 32px",
                  textTransform: "none",
                  minWidth: "120px",
                  "&:hover": {
                    backgroundColor: "#5f5bc4",
                  },
                  "&:disabled": {
                    backgroundColor: "#E0E0E0",
                    color: "#999",
                  },
                }}
              >
                {isValidatingPassword ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <CircularProgress size={16} sx={{ color: "#999" }} />
                    Validating...
                  </Box>
                ) : (
                  "Continue"
                )}
              </Button>
            </Box>
          </Box>
        </Dialog>
        <ReportView
          open={openReportView}
          onClose={() => {
            console.log('ReportView onClose called');
            setOpenReportView(false);
          }}
          candidateName={selectedApplicantDetails?.fullName || fullName}
          applicantId={selectedApplicantDetails?.userId}
          reportData={applicantReport}
          personalityData={applicantPersonality}
          topicScoreData={applicantTopicScore}
          scoreBandData={applicantScoreBand}
        />
      </>
    );
  }

  return (
    <>
      {desktopContent}
      {/* Comment Popup */}
      <CommentPopup
        open={openCommentModal}
        onClose={toggleCommentModal}
        jobId={jobId ? parseInt(jobId) : undefined}
        receiverId={selectedApplicantDetails?.userId}
      />
      {/* Share Popup */}
      <SharePopup
        open={openShareModal}
        onClose={toggleShareModal}
        selectedApplicantDetails={selectedApplicantDetails}
        selectedCandidates={selectedCandidates}
        jobId={jobId ? parseInt(jobId) : undefined}
        onShareSuccess={handleShareSuccess}
      />
      {/* Share Success Popup */}
      <ShareSuccessPopup
        open={openShareSuccessModal}
        onClose={toggleShareSuccessModal}
        shareUrl={shareSuccessUrl}
      />
      {/* Password Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={() => {
          // Prevent closing without password
          console.log('Password modal close attempted');
        }}
        fullScreen={isMobile}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown={true}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : "16px",
            padding: isMobile ? "24px" : "32px",
            margin: isMobile ? 0 : "32px",
            maxWidth: isMobile ? "100%" : "400px",
            zIndex: 1300,
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1299,
          },
        }}
        sx={{
          zIndex: 1300,
        }}
      >
        <Box sx={{
          width: "100%",
          backgroundColor: "white",
          outline: "none",
        }}>
          <Box sx={{ textAlign: "center", marginBottom: isMobile ? "20px" : "24px" }}>
            <Box sx={{ 
              width: isMobile ? "40px" : "48px", 
              height: isMobile ? "40px" : "48px", 
              backgroundColor: "#F5F5F5", 
              borderRadius: "50%", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              margin: "0 auto 16px auto",
              border: "2px solid #E0E0E0"
            }}>
              <Typography sx={{ fontSize: isMobile ? "20px" : "24px", color: "#666" }}>🔒</Typography>
            </Box>
            <Typography variant={isMobile ? "h6" : "h5"} sx={{ color: "#1F2235", fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "18px" : undefined }}>
              Password Required
            </Typography>
            <Typography variant="body2" sx={{ color: "#666", fontSize: isMobile ? "13px" : undefined }}>
              This share link is password protected. Please enter the password to continue.
            </Typography>
          </Box>

          <TextField
            fullWidth
            type="password"
            label="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordError(''); // Clear error when user types
            }}
            error={!!passwordError}
            helperText={passwordError}
            sx={{
              marginBottom: isMobile ? "20px" : "24px",
              '& .MuiOutlinedInput-root': {
                borderRadius: "999px",
                backgroundColor: passwordError ? "rgba(211, 47, 47, 0.02)" : "rgba(75, 68, 212, 0.02)",
                boxShadow: passwordError ? "inset 0px 0px 11px 2px rgba(211, 47, 47, 0.08)" : "inset 0px 0px 11px 2px rgba(75, 68, 212, 0.08)",
                fontFamily: "DM Sans",
                fontSize: "14px",
                fontWeight: 400,
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
              "& .MuiInputLabel-root": {
                fontFamily: "DM Sans",
                fontSize: "14px",
                fontWeight: 400,
                color: passwordError ? "#d32f2f" : "#666",
              },
              "& .MuiFormHelperText-root": {
                fontFamily: "DM Sans",
                fontSize: "12px",
                marginTop: "4px",
              },
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && !isValidatingPassword) {
                handlePasswordSubmit();
              }
            }}
          />

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handlePasswordSubmit}
              disabled={!password.trim() || isValidatingPassword}
              sx={{
                backgroundColor: "#756DE9",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                padding: "10px 32px",
                textTransform: "none",
                minWidth: "120px",
                "&:hover": {
                  backgroundColor: "#5f5bc4",
                },
                "&:disabled": {
                  backgroundColor: "#E0E0E0",
                  color: "#999",
                },
              }}
            >
              {isValidatingPassword ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <CircularProgress size={16} sx={{ color: "#999" }} />
                  Validating...
                </Box>
              ) : (
                "Continue"
              )}
            </Button>
          </Box>
        </Box>
      </Dialog>
      <ReportView
        open={openReportView}
        onClose={() => {
          console.log('ReportView onClose called');
          setOpenReportView(false);
        }}
        candidateName={selectedApplicantDetails?.fullName || fullName}
        applicantId={selectedApplicantDetails?.userId}
        reportData={applicantReport}
        personalityData={applicantPersonality}
        topicScoreData={applicantTopicScore}
        scoreBandData={applicantScoreBand}
      />
    </>
  );
};

export default ShareJobDetails;
